<template>
  <div class="pageView">
    <VideoHeader :showHangup="canHangup" @hangup="clickHangup" @changeCamera="changeCamera" :leftCamera="controller_data.videoOrAudioCall == 'video'"
                 :righthangup="true" rightIcons="false" :remoteuser="remoteuser" v-show="headerAndFooter"></VideoHeader>
    <p class="shareScreenTitle" v-show="tool_value.checkedShareScreen">画面共有中</p>
    <p class="curbitrate">{{ curbitrate }}</p>
    <div class="txt-area" v-show="tool_value.checkedSubtitle && audioText.length>0" style="z-index: 1">
      <div class="txt-area_inner">
        <p v-for="item in audioText" :key="item"> {{item}}</p>
      </div>
    </div>
    <div class="prototype mainDiv" @click="handleClick">
      <div class="prototype_inner" :class="[frame ? 'grid' : '']" >
        <div class="prototype-main-area" style="overflow:hidden;"
             :style="{ overflow:zoomFlg?'auto':'hidden', position: 'relative'}">
          <video v-show="tool_value.checkedCamera" id="remotevideo" autoplay webkit-playsinline playsinline muted="muted"
                 style="background-color: #000;transform-origin: 0 0"
                 :style="{ objectFit: 'contain',
            transform: zoomFlg ? 'scale(3)' : 'scale(1)',
             position: zoomFlg ? 'absolute' : 'relative',
             ...(zoomFlg && { left: 0, top: 0 }) }"
          />
          <div v-show="!tool_value.checkedCamera && showHangup" class="prompt_information">
            <span v-if="multiCallFlg">当通話保留<br/>新会話の通話待ち中</span>
            <span v-else-if="remoteuser!=null && remoteuser[4]!=''">{{ remoteuser[4] }}</span>
          </div>
          <div v-show="!showHangup" class="prompt_information">
            <span>接続中です...</span>
          </div>
          <p v-if="remoteuser != null && remoteuser[4] != ''" class="prototype-name prototype-name_you"
             :style="{display: frame ? 'block' : 'none',}">
            {{ remoteuser[4] }}
          </p>

        </div>
        <div v-show="my_video_show"
             class="prototype-share_sub-area" :class="[frame ? 'grid-view' : 'speaker-view']" :style="{ top: frame ? '' : '106px' }">
          <button v-show="!frame" class="share_sub-close" type="button" @click.stop="colseMyNameShow">
            <img :src="require('../../assets/img/prototype/btn_close-round.png')" alt="閉じる"/>
          </button>
          <div class="prototype-share_sub-inner">
            <div class="prototype-share_sub-view">
              <audio id="remoteaudio" autoplay playsinline></audio>
              <canvas ref="myCanvas" id="myCanvas" style="display: none;min-width:100px;"></canvas>
              <video id="soucevideo" autoplay webkit-playsinline playsinline muted="muted"
                     style="display: none;width: 100%;height: 100%;object-fit: cover; min-width: 100px"/>
              <video id="myvideo" autoplay webkit-playsinline playsinline muted="muted"
                     style="background-color: #000;height:100%;width:100%;object-fit: contain;" />
              <p v-if="myuser != null && myuser[4] != ''" class="prototype-name prototype-name_you" >
                {{ myuser[4] }}
              </p>
            </div>
          </div>
        </div>
        <!-- 切换按钮 -->
        <div class="video_view-change_btn" style="top: 100px" v-show="!checkedShow">
          <div :style="changeViewShow?'display:block;':'display:none;'" class="main-btn" @click.stop="changeFrame">画面表示切り替え</div>
          <div :style="changeViewShow?'display:none;':'display:block;'" :class = "frame?'':'select'"
               class="change-btn change-btn_speaker" @click.stop="changeView('speaker')">スピーカービュー</div>
          <div :style="changeViewShow?'display:none;':'display:block;'" :class = "frame?'select':''"
               class="change-btn change-btn_grid" @click.stop="changeView('grid')">ギャラリービュー</div>
        </div>
      </div>
      <div v-show="showMyvideoButton" @click.stop="clickMyvideoButton" class="video-sub-area_re-btn open">
        <a class="re-btn">再表示</a>
      </div>
    </div>
    <div class="video-setting-box" :class="detailShow ? 'open' : ''">
      <div class="video-setting-box_inner">
        <div class="video-setting-top">
          <p class="video-setting-title">詳細設定</p>
          <a class="video-setting-close"  @click="saveDetail" >完了</a>
        </div>
        <div class="video_switching-list">
          <div v-if="!isFamilyPatientCall" class="video_switching-item video_sw_item">
            <p class="video_switching-name">バーチャル背景</p>
            <div class="video_switching-box" :class="tool_value.checkedBackground?'':'checked'" @click="changeCheckBoxValue('checkedBackground')">
              <input class="toggle_input" type='checkbox' />
            </div>
          </div>
          <div v-if="!isFamilyPatientCall" class="video_switching-item video_sw_item">
            <p class="video_switching-name">背景をぼかす</p>
            <div class="video_switching-box" :class="tool_value.checkedBlurBackground?'':'checked'" @click="changeCheckBoxValue('checkedBlurBackground')">
              <input class="toggle_input" type='checkbox' />
            </div>
          </div>
          <div class="video_switching-item video_sw_item"
               v-if="canRecordCurrentCall">
            <p class="video_switching-name">画面を録画する</p>
            <div class="video_switching-box" :class="tool_value.checkedVideotape?'':'checked'" @click="changeCheckBoxValue('checkedVideotape')">
              <input class="toggle_input" type='checkbox' />
            </div>
          </div>
          <div v-if="!isFamilyPatientCall" class="video_switching-item video_sw_item">
            <p class="video_switching-name">音声字幕</p>
            <div class="video_switching-box" :class="tool_value.checkedSubtitle?'':'checked'" @click="changeCheckBoxValue('checkedSubtitle')">
              <input class="toggle_input" type='checkbox' />
            </div>
          </div>
          <div v-if="canAddUsersToCall" class="video_switching-item video_sw_item" @click="showUserModel">
            <p class="video_switching-name">通話ユーザー追加</p>
          </div>
          <div class="video_switching-item video_sw_item"
               v-if="canUseCameraAudioRemoteControl">
            <p class="video_switching-name">カメラON/OFF 遠隔操作</p>
            <div class="video_switching-box" :class="tool_value.checkedCamera?'':'checked'" @click="changeCheckBoxValue('checkedCamera')">
              <input class="toggle_input" type='checkbox' />
            </div>
          </div>
          <div class="video_switching-item video_sw_item"
               v-if="canUseCameraAudioRemoteControl">
            <p class="video_switching-name">音声ON/OFF 遠隔操作</p>
            <div class="video_switching-box" :class="tool_value.checkedAudio?'':'checked'" @click="changeCheckBoxValue('checkedAudio')">
              <input class="toggle_input" type='checkbox' />
            </div>
          </div>
          <div class="video_switching-item video_sw_item"
               v-if="canUseRemoteControl">
            <p class="video_switching-name">バックカメラの切り替え 遠隔操作</p>
            <div class="video_switching-box" :class="tool_value.checkedCameraRear?'':'checked'" @click="changeCheckBoxValue('checkedCameraRear')">
              <input class="toggle_input" type='checkbox'  />
            </div>
          </div>
          <div class="video_switching-item video_sw_item">
            <p class="video_switching-name">自身画面表示ON/OFF</p>
            <div class="video_switching-box" :class="tool_value.checkedSelfView?'':'checked'" @click="changeCheckBoxValue('checkedSelfView')">
              <input class="toggle_input" type='checkbox' />
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="footDiv"  v-show="headerAndFooter && showHangup" :style="`grid-template-columns:repeat(${footerGridColumns},1fr)`">
      <div class="footDiv-item" >
        <img
            :src="[controller_data.mkShow ? require('../../assets/img/video/video_menu_mike_on.svg')
              : require('../../assets/img/video/video_menu_mike_off.svg')]"
            alt="マイク"
            @click="changeShow('mike')"
        />
        <p class="iconSpan">マイク</p>
      </div>
      <div class="footDiv-item" v-show="!footerItem">
        <img
            :src="[controller_data.viShow ? require('../../assets/img/video/video_menu_video_on.svg')
              : require('../../assets/img/video/video_menu_video_off.svg')]"
            alt="ビデオ"
            @click="changeShow('video')"
        />
        <p class="iconSpan">ビデオ</p>
      </div>
      <div class="footDiv-item" v-show="showShareScreenButton">
        <img
            :src="require('../../assets/img/video/video_menu_video_share.svg')"
            @click="shareScreen()"
        />
        <p class="iconSpan">画面共有</p>
      </div>
      <div class="footDiv-item" v-show="showDetailButton">
        <img
            :src="require('../../assets/img/video/video_menu_setting.svg')"
            @click="openDetail"
        />
        <p class="iconSpan">設定</p>
      </div>
    </div>

    <div class="popup-bg" v-if="userModelShow">
      <div class="popup">
        <div class="btn">
          <div @click="cancelUserModel" class="cancle">キャンセル</div>
          <div @click="confirmUserModel" class="confirm">通話</div>
        </div>
        <van-radio-group v-model="multiCallUserId">
          <van-cell-group inset>
            <van-cell v-for="item in sameTeamDoctorList" :key="item.account_id"
                      :title="item.name" clickable @click="chooseUser(item)">
              <template #right-icon>
                <van-radio :name="item.account_id" />
              </template>
            </van-cell>
          </van-cell-group>
        </van-radio-group>
      </div>
    </div>
  </div>
</template>

<script>

import { markRaw } from "vue";
import VideoHeader from "@/components/Header-video.vue";
import {Dialog, Toast} from "vant";
import { randNumStr, randPwd,} from "@/utils/rand";
import Janus from "@/assets/js/janus";
import {CheckOperationAuth, FindSameTeamMembers, GetDoctorDetail} from "@/services/team";
import {SelfieSegmentation} from "@mediapipe/selfie_segmentation";
import {RefreshUserInfo} from "@/services/login";
import * as StackBlur from 'stackblur-canvas';
import { getCallStatus, saveCallLog, saveCallLogWithBeacon } from "@/services/video";
import {doSend} from "@/utils/websocket";
import {changeMessageStatus, pushMessage} from "@/services/pushmessage";
import {GetPatientDetails} from "@/services/patient";
import { UpdateUserWithoutId} from "@/services/user";
import { runIosAudioSessionAction as scheduleIosAudioSessionAction } from "@/utils/iosAudioSession";
import { destroyJanusSession } from "@/utils/janusSession";


export default {
  data() {
    return {
      // 通话时间上限 自动挂断
      callLimitToastTimeOut:null,
      callLimitHangTimeOut:null,
      // janus用
      janus_server: process.env.VUE_APP_JANUS_SERVER,
      opaqueId: "videoroomtest-" + Janus.randomString(12),
      janus: null,
      videocall: null,
      jsep: null,
      registerName: "",
      sendStream :null,
      // 通话对方名
      remoteuser:null,
      // 通话自身名
      myuser: null,
      // 头部底部栏显示
      headerAndFooter:true,
      // 比特率
      bitrateTimer: null,
      curbitrate:"",
      // 画面布局类别
      frame: false,
      // 底部功能栏显示
      footerItem: true,
      // 底部功能栏目项目
      controller_data:{
        // 页面下方按钮
        viShow: true,
        mkShow: true,
        videoOrAudioCall:"",
        userType:"",
        answerUser:"",
        callType:"",
      },
      tool_value:{
        // 底部功能栏目项目
        checkedVideotape: false, // 画面を録画する
        checkedBackground: false, // 虚拟背景
        checkedBlurBackground: false, // 虚化背景
        checkedSubtitle: false, // 音声字幕
        checkedCamera: false, // カメラON/OFF
        checkedAudio: false, // 音声ON/OFF
        checkedCameraRear: false, // バックカメラの切り替え
        checkedShareScreen:false, // 画面共有
        checkedSelfView: true, // 自身画面表示ON/OFF（スピーカービューのみ有効）
      },
      back_tool_value:{
        // 底部功能栏目项目备份
        checkedVideotape: false,
        checkedBackground: false,
        checkedBlurBackground: false,
        checkedSubtitle: false,
        checkedCamera: false,
        checkedAudio: false,
        checkedCameraRear: false,
        checkedShareScreen: false,
        checkedSelfView: true,
      },
      // 翻转摄像头用
      facingMode:'user',
      // 再表示按钮显示
      showMyvideoButton: false,
      // 虚拟背景用
      context:null,
      image: null,
      rafId: null,
      canvasSourceStream:null,
      // 语音转文字用
      recognition:null,
      audioText:[],
      audioEndFlg:true,
      // 自身视频显示
      my_video_show:true,
      clickTimer:null,
      // 切换按钮显示
      checkedShow: true,
      changeViewShow:true,
      // 底部工具栏拉起状态
      detailShow: false,
      // 屏幕共有用视频流
      shareScreenStream:null,
      // 录制视频用
      isRecording: false,
      recordDisable: false,
      // 接续完成后才开放通话控制；结束按钮在建连期间也可使用。
      showHangup:false,
      //是否有人call
      haveCall:false,
      //确保返回只执行一次。
      callReturnPage:false,
      //录制时，文件名
      record_filename:"",
      //记录用户的数据,避免多次请求
      userRet:null,
      //记录本地流是否成功获取
      waitLocalStream:true,
      // 摄像头获取
      permissionError:false,
      // 多人通话
      multiCallFlg: false,
      userModelShow : false,
      sameTeamDoctorList : [],
      multiCallId: null,
      multiCallUser : null,
      multiCallUserId : null,
      pauseCallValue:{},
      multiCallInitiator :false,
      multiCallWaitUser:null,
      multiWaitFlg:false,
      userCAgreeFlg:false,
      // 手动点击挂断标识
      clickHangupFlg:false,
      // 对方屏幕共享状态
      remoteShareScreenStatus:false,
      // 缩放用
      zoomFlg:false,
      // 通话状态校验
      callStatusCheckTimer:null,
      callStatusMonitorTimer:null,
      callStatusCheckInFlight:false,
      lastCallStatusCheckAt:0,
      callStatusMonitorInterval:0,
      skipBeforeUnmountHangup:false,
      endCallLogSaved:false,
      connectionIssueDetected:false,
      connectionLostPending:false,
      connectionIssueStartedAt:0,
      stableCallStatusMonitorMs:5000,
      issueCallStatusMonitorMs:2000,
      connectionIssueGraceMs:12000,
      remoteAudioTrackActive:false,
      remoteVideoTrackActive:false,
      dataChannelOpen:false,
      heartbeatTimer:null,
      heartbeatIntervalMs:3000,
      heartbeatTimeoutMs:9000,
      lastHeartbeatSentAt:0,
      lastPeerHeartbeatAt:0,
      localAudioTrack:null,
      localVideoTrack:null,
      callAudioInputStream:null,
      callAudioOutputTrack:null,
      callAudioContext:null,
      callAudioSourceNode:null,
      callAudioGainNode:null,
      callAudioDestination:null,
      callAudioGainValue:2.2,
      callSetupTimer:null,
      callSetupTimeoutMs:45000,
      callMediaConnected:false,
      peerLookupTimer:null,
      peerLookupAttempt:0,
      peerLookupBaseDelayMs:800,
      peerLookupMaxDelayMs:3000,
      sendStreamInitPromise:null,
      callOfferRequested:false,
      answerRequestHandled:false,
      callInitRetryCount:0,
      maxCallInitRetryCount:1,
      callSessionAttemptId:0,
      callMediaRequestId:0,
      localHangupPending:false,
    };
  },
  components: {
    VideoHeader,
  },
  computed: {
    canHangup() {
      return !this.callReturnPage;
    },
    isFamilyPatientCall() {
      return this.controller_data.callType == "7";
    },
    isFamilyRemoteController() {
      return (
        this.isFamilyPatientCall &&
        this.controller_data.userType == "callUser"
      );
    },
    canUseRemoteControl() {
      if (this.isFamilyPatientCall) {
        return false;
      }
      return (
        (this.controller_data.callType == "1" &&
          this.controller_data.userType == "answerUser") ||
        (this.controller_data.callType == "2" &&
          this.controller_data.userType == "callUser")
      );
    },
    canUseCameraAudioRemoteControl() {
      return this.canUseRemoteControl || this.isFamilyRemoteController;
    },
    canRecordCurrentCall() {
      return this.canUseRemoteControl;
    },
    canAddUsersToCall() {
      if (this.isFamilyPatientCall) {
        return false;
      }
      return this.canUseRemoteControl || this.controller_data.callType == "3";
    },
    showShareScreenButton() {
      return !this.footerItem && !this.isFamilyPatientCall;
    },
    showDetailButton() {
      return !this.footerItem;
    },
    footerGridColumns() {
      if (this.footerItem) {
        return 1;
      }
      return this.isFamilyPatientCall ? 3 : 4;
    },
  },
  mounted() {
    this.$store.state.routeViewComponent = this;
    window.addEventListener("online", this.handleNetworkReconnect);
    window.addEventListener("offline", this.handleNetworkOffline);
    window.addEventListener("pagehide", this.handlePageHide);
    document.addEventListener("resume", this.handleAppResume, false);
    document.addEventListener("click", this.resumeCallAudioPlayback);
    // 进入通话流程前，检测dz认证是否开启，如果已经开启了，暂时暂停认证功能，退出页面时再开启

    // 在特殊页面中调用如下代码，将特殊页面从历史记录中删除：
    this.printNow("started")

    if(!this.$store.state.inCallingPage){
      this.returnPage()
    }else{
      this.initPage();
    }
  },
  beforeUnmount() {
    window.removeEventListener("online", this.handleNetworkReconnect);
    window.removeEventListener("offline", this.handleNetworkOffline);
    window.removeEventListener("pagehide", this.handlePageHide);
    document.removeEventListener("resume", this.handleAppResume, false);
    document.removeEventListener("click", this.resumeCallAudioPlayback);
    this.clearCallStatusCheckTimer();
    this.stopHeartbeatMonitor();
    this.stopCallSetupMonitor();
    this.stopPeerLookup();
    if(!this.skipBeforeUnmountHangup){
      this.doHangup();
    }
    this.$store.state.routeViewComponent = null;
    if(this.callLimitToastTimeOut){
      clearTimeout(this.callLimitToastTimeOut);
    }
    if(this.callLimitHangTimeOut){
      clearTimeout(this.callLimitHangTimeOut);
    }
  },
  methods: {
    runIosAudioSessionAction(action, delay = 0) {
      scheduleIosAudioSessionAction(action, {
        delay,
        onError: (error) =>
          console.log(`ios audio session ${action} failed:`, error),
      });
    },
    resumeCallAudioPlayback() {
      const audioElement = document.getElementById("remoteaudio");
      if (audioElement?.paused) {
        audioElement.play().catch((error) => {
          console.log("remoteaudio play failed:", error);
        });
      }
    },
    isCurrentCallSession(attemptId, session = null) {
      return (
        !this.callReturnPage &&
        attemptId === this.callSessionAttemptId &&
        (!session || session === this.janus)
      );
    },
    destroyCallSession(session = this.janus, cleanupHandles = true) {
      if (session === this.janus) {
        this.callSessionAttemptId++;
        this.callMediaRequestId++;
        this.janus = null;
        this.videocall = null;
      }
      if (!session) {
        return;
      }
      destroyJanusSession(session, { cleanupHandles });
    },
    getCallAudioCaptureConstraints() {
      return {
        echoCancellation: true,
        noiseSuppression: true,
        autoGainControl: false,
        channelCount: { ideal: 1 },
        sampleRate: { ideal: 48000 },
        sampleSize: { ideal: 16 },
      };
    },
    async createAmplifiedCallAudioTrack(requestId = this.callMediaRequestId) {
      if (requestId !== this.callMediaRequestId) {
        return null;
      }
      if (
        this.callAudioOutputTrack &&
        this.callAudioOutputTrack.readyState === "live"
      ) {
        return this.callAudioOutputTrack;
      }
      const AudioContextClass =
        window.AudioContext || window.webkitAudioContext;
      if (!AudioContextClass || !navigator.mediaDevices?.getUserMedia) {
        return null;
      }
      const inputStream = await navigator.mediaDevices.getUserMedia({
        audio: this.getCallAudioCaptureConstraints(),
        video: false,
      });
      if (requestId !== this.callMediaRequestId) {
        this.stopMediaTarget(inputStream);
        return null;
      }
      const audioContext = new AudioContextClass();
      try {
        if (audioContext.state === "suspended") {
          await audioContext.resume();
        }
      } catch (error) {
        console.log("resume audio context failed:", error);
      }
      if (requestId !== this.callMediaRequestId) {
        this.stopMediaTarget(inputStream);
        if (typeof audioContext.close === "function") {
          audioContext.close().catch(() => {});
        }
        return null;
      }
      if (audioContext.state !== "running") {
        this.callAudioInputStream = inputStream;
        this.callAudioOutputTrack = inputStream.getAudioTracks()[0] || null;
        this.callAudioContext = audioContext;
        return this.callAudioOutputTrack;
      }
      const sourceNode = audioContext.createMediaStreamSource(inputStream);
      const highPassFilterNode = audioContext.createBiquadFilter();
      highPassFilterNode.type = "highpass";
      highPassFilterNode.frequency.value = 140;
      highPassFilterNode.Q.value = 0.7;
      let outputNode = highPassFilterNode;
      if (typeof audioContext.createDynamicsCompressor === "function") {
        const compressorNode = audioContext.createDynamicsCompressor();
        compressorNode.threshold.value = -24;
        compressorNode.knee.value = 18;
        compressorNode.ratio.value = 3;
        compressorNode.attack.value = 0.003;
        compressorNode.release.value = 0.2;
        highPassFilterNode.connect(compressorNode);
        outputNode = compressorNode;
      }
      const gainNode = audioContext.createGain();
      gainNode.gain.value = this.callAudioGainValue;
      const destinationNode = audioContext.createMediaStreamDestination();
      sourceNode.connect(highPassFilterNode);
      outputNode.connect(gainNode);
      gainNode.connect(destinationNode);
      const outputTrack = destinationNode.stream.getAudioTracks()[0] || null;
      this.callAudioInputStream = inputStream;
      this.callAudioOutputTrack = outputTrack;
      this.callAudioContext = audioContext;
      this.callAudioSourceNode = sourceNode;
      this.callAudioGainNode = gainNode;
      this.callAudioDestination = destinationNode;
      return outputTrack;
    },
    async buildCallAudioTrackConfig(
      recv = true,
      requestId = this.callMediaRequestId
    ) {
      try {
        const audioTrack = await this.createAmplifiedCallAudioTrack(requestId);
        if (audioTrack) {
          return {
            type: "audio",
            capture: audioTrack,
            recv,
          };
        }
      } catch (error) {
        console.log("create amplified call audio track failed:", error);
      }
      return {
        type: "audio",
        capture: this.getCallAudioCaptureConstraints(),
        recv,
      };
    },
    releaseCallAudioProcessing() {
      if (this.callAudioOutputTrack && this.callAudioOutputTrack !== this.localAudioTrack) {
        this.stopMediaTarget(this.callAudioOutputTrack);
      }
      if (this.callAudioInputStream) {
        this.stopMediaTarget(this.callAudioInputStream);
      }
      if (
        this.callAudioContext &&
        typeof this.callAudioContext.close === "function" &&
        this.callAudioContext.state !== "closed"
      ) {
        this.callAudioContext.close().catch((error) => {
          console.log("close audio context failed:", error);
        });
      }
      this.callAudioInputStream = null;
      this.callAudioOutputTrack = null;
      this.callAudioContext = null;
      this.callAudioSourceNode = null;
      this.callAudioGainNode = null;
      this.callAudioDestination = null;
    },
    isBrowserOnline() {
      if (typeof navigator === "undefined") {
        return true;
      }
      return navigator.onLine !== false;
    },
    isClientOffline() {
      const webSocketStatus = localStorage.getItem("tsunagaru-websocket");
      return !this.isBrowserOnline() || webSocketStatus === "offline";
    },
    handleNetworkReconnect() {
      this.scheduleCallStatusCheck(300, true);
    },
    handleNetworkOffline() {
      this.markConnectionIssue();
    },
    handlePageHide() {
      if (this.callReturnPage) {
        return;
      }
      this.saveCurrentCallEndLog(true);
    },
    handleAppResume() {
      this.scheduleCallStatusCheck(300, true);
    },
    clearCallStatusCheckTimer() {
      if(this.callStatusCheckTimer){
        clearTimeout(this.callStatusCheckTimer);
        this.callStatusCheckTimer = null;
      }
      if(this.callStatusMonitorTimer){
        clearInterval(this.callStatusMonitorTimer);
        this.callStatusMonitorTimer = null;
      }
      this.callStatusMonitorInterval = 0;
    },
    startCallStatusMonitor(interval = this.stableCallStatusMonitorMs, forceRestart = false) {
      if (this.callReturnPage || !this.$route.query.callId) {
        return;
      }
      if (this.callStatusMonitorTimer && !forceRestart && this.callStatusMonitorInterval === interval) {
        return;
      }
      this.stopCallStatusMonitor();
      this.callStatusMonitorInterval = interval;
      this.callStatusMonitorTimer = setInterval(() => {
        this.verifyCurrentCallStatus();
      }, interval);
    },
    stopCallStatusMonitor() {
      if(this.callStatusMonitorTimer){
        clearInterval(this.callStatusMonitorTimer);
        this.callStatusMonitorTimer = null;
      }
      this.callStatusMonitorInterval = 0;
    },
    startCallSetupMonitor() {
      this.stopCallSetupMonitor();
      this.callSetupTimer = setTimeout(() => {
        this.callSetupTimer = null;
        if (this.callReturnPage || this.isCallSetupComplete()) {
          return;
        }
        if (this.showHangup) {
          Toast.fail("接続できませんでした。");
          this.finalizeAbnormalEnd(true);
          return;
        }
        this.handleCallSetupFailure("setup_timeout");
      }, this.callSetupTimeoutMs);
    },
    stopCallSetupMonitor() {
      if (this.callSetupTimer) {
        clearTimeout(this.callSetupTimer);
        this.callSetupTimer = null;
      }
    },
    stopPeerLookup() {
      if (this.peerLookupTimer) {
        clearTimeout(this.peerLookupTimer);
        this.peerLookupTimer = null;
      }
    },
    schedulePeerLookup() {
      if (
        this.callReturnPage ||
        this.showHangup ||
        this.controller_data.userType !== "callUser" ||
        this.callOfferRequested ||
        !this.videocall
      ) {
        return;
      }
      this.stopPeerLookup();
      const delay = Math.min(
        this.peerLookupBaseDelayMs * Math.max(1, this.peerLookupAttempt + 1),
        this.peerLookupMaxDelayMs
      );
      this.peerLookupTimer = setTimeout(() => {
        this.peerLookupTimer = null;
        this.peerLookupAttempt++;
        this.getCurRegisteredUserList();
      }, delay);
    },
    resetCallSetupState() {
      this.stopPeerLookup();
      this.stopCallSetupMonitor();
      this.sendStreamInitPromise = null;
      this.callOfferRequested = false;
      this.answerRequestHandled = false;
      this.peerLookupAttempt = 0;
      this.localHangupPending = false;
      this.waitLocalStream = true;
      this.permissionError = false;
      this.callMediaConnected = false;
    },
    isCallSetupComplete() {
      return this.showHangup && this.callMediaConnected;
    },
    completeCallSetupIfReady() {
      if (!this.isCallSetupComplete()) {
        return false;
      }
      this.stopCallSetupMonitor();
      return true;
    },
    markCallMediaConnected() {
      if (this.callReturnPage) {
        return;
      }
      this.callMediaConnected = true;
      this.clearConnectionIssue();
    },
    stopMediaTarget(mediaTarget) {
      if (!mediaTarget) {
        return;
      }
      if (typeof mediaTarget.getTracks === "function") {
        mediaTarget.getTracks().forEach((track) => {
          if (track && typeof track.stop === "function") {
            track.stop();
          }
        });
        return;
      }
      if (typeof mediaTarget.stop === "function") {
        mediaTarget.stop();
      }
    },
    getMediaTrack(mediaTarget, kind) {
      if (!mediaTarget) {
        return null;
      }
      if (
        typeof MediaStreamTrack !== "undefined" &&
        mediaTarget instanceof MediaStreamTrack
      ) {
        return mediaTarget.kind === kind ? mediaTarget : null;
      }
      const getter = kind === "audio" ? "getAudioTracks" : "getVideoTracks";
      if (typeof mediaTarget[getter] !== "function") {
        return null;
      }
      return mediaTarget[getter]()[0] || null;
    },
    stopLocalMediaStreams() {
      this.releaseCallAudioProcessing();
      if (this.localAudioTrack) {
        this.stopMediaTarget(this.localAudioTrack);
        this.localAudioTrack = null;
      }
      if (this.localVideoTrack) {
        this.stopMediaTarget(this.localVideoTrack);
        this.localVideoTrack = null;
      }
      const janusStream = this.videocall?.webrtcStuff?.myStream;
      if (janusStream) {
        this.stopMediaTarget(janusStream);
      }
      if (this.shareScreenStream) {
        this.stopMediaTarget(this.shareScreenStream);
        this.shareScreenStream = null;
      }
      if (this.sendStream) {
        this.stopMediaTarget(this.sendStream);
        this.sendStream = null;
      }
      this.stopSpeechRecognition();
      this.stopCanvas();
      this.clearMediaElements();
    },
    stopSpeechRecognition() {
      this.audioEndFlg = true;
      if (this.recognition) {
        try {
          this.recognition.stop();
        } catch (error) {
          console.log(error);
        }
      }
    },
    clearMediaElements() {
      ["#myvideo", "#soucevideo", "#remotevideo", "#remoteaudio"].forEach((selector) => {
        const element = JQuery(selector).get(0);
        if (!element) {
          return;
        }
        try {
          element.pause?.();
        } catch (error) {
          console.log(error);
        }
        element.srcObject = null;
      });
    },
    async retryCallSetup(reason) {
      if (this.callReturnPage || this.showHangup) {
        return false;
      }
      if (this.callInitRetryCount >= this.maxCallInitRetryCount) {
        return false;
      }
      this.callInitRetryCount++;
      console.log("retryCallSetup", reason, this.callInitRetryCount);
      this.stopPeerLookup();
      this.stopHeartbeatMonitor();
      this.stopCallStatusMonitor();
      this.stopLocalMediaStreams();
      this.callMediaRequestId++;
      this.destroyCallSession();
      this.jsep = null;
      this.remoteAudioTrackActive = false;
      this.remoteVideoTrackActive = false;
      this.dataChannelOpen = false;
      this.callOfferRequested = false;
      this.answerRequestHandled = false;
      this.localHangupPending = false;
      this.waitLocalStream = true;
      this.permissionError = false;
      this.callMediaConnected = false;
      this.sendStreamInitPromise = null;
      this.startCallSetupMonitor();
      setTimeout(() => {
        if (!this.callReturnPage) {
          this.initJanus();
        }
      }, 800);
      return true;
    },
    async handleCallSetupFailure(reason) {
      if (this.callReturnPage || this.showHangup) {
        return;
      }
      const retried = await this.retryCallSetup(reason);
      if (retried) {
        return;
      }
      Toast.fail("接続できませんでした。");
      this.finalizeAbnormalEnd(true);
    },
    startHeartbeatMonitor() {
      if (this.heartbeatTimer || this.callReturnPage) {
        return;
      }
      this.lastHeartbeatSentAt = 0;
      if (!this.lastPeerHeartbeatAt) {
        this.lastPeerHeartbeatAt = Date.now();
      }
      this.heartbeatTimer = setInterval(() => {
        this.runHeartbeatMonitor();
      }, 1000);
    },
    stopHeartbeatMonitor() {
      if (this.heartbeatTimer) {
        clearInterval(this.heartbeatTimer);
        this.heartbeatTimer = null;
      }
      this.dataChannelOpen = false;
      this.lastHeartbeatSentAt = 0;
      this.lastPeerHeartbeatAt = 0;
    },
    runHeartbeatMonitor() {
      if (this.callReturnPage || !this.showHangup) {
        return;
      }
      const now = Date.now();
      if (!this.dataChannelOpen) {
        return;
      }
      if (this.videocall && now - this.lastHeartbeatSentAt >= this.heartbeatIntervalMs) {
        this.sendHeartbeat("ping");
      }
      if (!this.lastPeerHeartbeatAt) {
        return;
      }
      if (now - this.lastPeerHeartbeatAt < this.heartbeatTimeoutMs) {
        return;
      }
      this.markConnectionIssue();
      if (!this.isClientOffline()) {
        this.scheduleCallStatusCheck(300, true);
      }
    },
    sendHeartbeat(type = "ping") {
      if (!this.videocall || !this.dataChannelOpen) {
        return;
      }
      this.lastHeartbeatSentAt = Date.now();
      this.videocall.data({
        text: JSON.stringify({
          method: type === "pong" ? "callHeartbeatPong" : "callHeartbeatPing",
          at: this.lastHeartbeatSentAt,
        }),
        error: () => {
          if (type === "ping") {
            this.markConnectionIssue();
          }
        },
        success: function () {},
      });
    },
    touchPeerHeartbeat() {
      this.lastPeerHeartbeatAt = Date.now();
      if (this.connectionIssueDetected && this.videocall && !this.isClientOffline()) {
        this.clearConnectionIssue();
      }
    },
    handleHeartbeatMessage(data) {
      if (!data || !data.method) {
        return false;
      }
      if (data.method === "callHeartbeatPing") {
        this.touchPeerHeartbeat();
        this.sendHeartbeat("pong");
        return true;
      }
      if (data.method === "callHeartbeatPong") {
        this.touchPeerHeartbeat();
        return true;
      }
      return false;
    },
    showConnectionIssueOverlay() {
      if (!this.isClientOffline()) {
        return;
      }
      if (this.$root) {
        this.$root.netOnline = false;
        if (typeof this.$root.createDialogInstance === "function") {
          this.$root.createDialogInstance();
        }
      }
    },
    hideConnectionIssueOverlay() {
      if (this.$root) {
        this.$root.netOnline = true;
        if (this.$root.dialogInstance && typeof this.$root.dialogInstance.close === "function") {
          this.$root.dialogInstance.close();
          this.$root.dialogInstance = null;
        }
      }
    },
    clearConnectionIssue() {
      this.connectionIssueDetected = false;
      this.connectionLostPending = false;
      this.connectionIssueStartedAt = 0;
      this.hideConnectionIssueOverlay();
      if (this.showHangup) {
        this.completeCallSetupIfReady();
        this.stopPeerLookup();
        this.touchPeerHeartbeat();
        this.startHeartbeatMonitor();
        this.startCallStatusMonitor(this.stableCallStatusMonitorMs, true);
      } else {
        this.stopHeartbeatMonitor();
        this.stopCallStatusMonitor();
      }
    },
    markConnectionIssue() {
      if (!this.connectionIssueDetected) {
        this.connectionIssueStartedAt = Date.now();
      }
      this.connectionIssueDetected = true;
      if (this.isClientOffline()) {
        this.connectionLostPending = true;
      }
      this.showConnectionIssueOverlay();
      this.startHeartbeatMonitor();
      this.startCallStatusMonitor(this.issueCallStatusMonitorMs, true);
    },
    handleCallRuntimeFailure() {
      if (this.callReturnPage) {
        return true;
      }
      if (this.showHangup || this.isClientOffline() || this.connectionIssueDetected) {
        this.markConnectionIssue();
        if (!this.isClientOffline()) {
          this.scheduleCallStatusCheck(300, true);
        }
        return true;
      }
      return false;
    },
    handlePeerHangupEvent(reason = "peer_hangup") {
      if (this.callReturnPage) {
        return;
      }
      if (!this.showHangup) {
        this.handleCallSetupFailure(reason);
        return;
      }
      if (this.isClientOffline()) {
        this.connectionLostPending = true;
        this.markConnectionIssue();
        return;
      }
      this.finalizeAbnormalEnd(true);
    },
    bindRemoteTrackEvents(track, kind, attemptId, session) {
      if (!track || track.__tsunagaruTrackEventsBound) {
        return;
      }
      track.__tsunagaruTrackEventsBound = true;
      track.addEventListener("ended", () => {
        if (!this.isCurrentCallSession(attemptId, session)) {
          return;
        }
        if (kind === "audio") {
          this.remoteAudioTrackActive = false;
        } else {
          this.remoteVideoTrackActive = false;
          this.tool_value.checkedCamera = false;
        }
        this.evaluateRemoteMediaState();
      });
      track.addEventListener("mute", () => {
        if (
          !this.isCurrentCallSession(attemptId, session) ||
          this.callReturnPage ||
          !this.showHangup
        ) {
          return;
        }
        this.markConnectionIssue();
        if (!this.isClientOffline()) {
          this.scheduleCallStatusCheck(300, true);
        }
      });
      track.addEventListener("unmute", () => {
        if (!this.isCurrentCallSession(attemptId, session)) {
          return;
        }
        if (kind === "audio") {
          this.remoteAudioTrackActive = true;
        } else {
          this.remoteVideoTrackActive = true;
          this.tool_value.checkedCamera = true;
        }
        this.touchPeerHeartbeat();
        if (!this.isClientOffline()) {
          this.clearConnectionIssue();
        }
      });
    },
    evaluateRemoteMediaState() {
      if (!this.showHangup || this.callReturnPage) {
        return;
      }
      const remoteMediaActive = this.controller_data.videoOrAudioCall === "audio"
        ? this.remoteAudioTrackActive
        : (this.remoteAudioTrackActive || this.remoteVideoTrackActive);
      if (!remoteMediaActive) {
        this.markConnectionIssue();
        if (!this.isClientOffline()) {
          this.scheduleCallStatusCheck(300, true);
        }
      }
    },
    scheduleCallStatusCheck(delay = 0, force = false) {
      if (this.callReturnPage || !this.$route.query.callId) {
        return;
      }
      this.clearCallStatusCheckTimer();
      if (delay <= 0) {
        this.verifyCurrentCallStatus(force);
        return;
      }
      this.callStatusCheckTimer = setTimeout(() => {
        this.callStatusCheckTimer = null;
        this.verifyCurrentCallStatus(force);
      }, delay);
    },
    async verifyCurrentCallStatus(force = false) {
      if (this.callReturnPage || !this.$route.query.callId || this.isClientOffline()) {
        return;
      }
      const now = Date.now();
      if (this.callStatusCheckInFlight) {
        return;
      }
      if (!force && now - this.lastCallStatusCheckAt < 3000) {
        return;
      }
      this.callStatusCheckInFlight = true;
      this.lastCallStatusCheckAt = now;
      try {
        const res = await getCallStatus({ call_id: this.$route.query.callId });
        const callStatus = res?.data?.data;
        if (!callStatus?.active) {
          this.finalizeAbnormalEnd();
          return;
        }
        if (!this.showHangup) {
          return;
        }
        if (!this.connectionIssueDetected) {
          this.startCallStatusMonitor(this.stableCallStatusMonitorMs);
          return;
        }
        const issueDuration = this.connectionIssueStartedAt > 0
          ? now - this.connectionIssueStartedAt
          : 0;
        const shouldFinalizeAbnormalEnd = this.connectionLostPending
          || !this.videocall
          || issueDuration >= this.connectionIssueGraceMs;
        if (shouldFinalizeAbnormalEnd) {
          this.finalizeAbnormalEnd(true);
          return;
        }
        this.startCallStatusMonitor(this.issueCallStatusMonitorMs);
      } catch (error) {
        console.log("verifyCurrentCallStatus error", error);
      } finally {
        this.callStatusCheckInFlight = false;
      }
    },
    saveCurrentCallEndLog(preferBeacon = false) {
      if (this.endCallLogSaved || !this.$route.query.callId) {
        return;
      }
      this.endCallLogSaved = true;
      const msg = {
        call_id:this.$route.query.callId,
        send_type:"hangup"
      };
      console.log(msg);
      if (preferBeacon) {
        const sent = saveCallLogWithBeacon(msg);
        if (!sent) {
          saveCallLog(msg);
        }
        return;
      }
      saveCallLog(msg);
    },
    finalizeAbnormalEnd(saveLog = false) {
      this.clearConnectionIssue();
      this.stopCallStatusMonitor();
      this.stopHeartbeatMonitor();
      if (saveLog) {
        this.saveCurrentCallEndLog();
      }
      this.returnPage({ skipRootLog: true });
    },
    doMethods(params){
      // 父级页面执行的方法
      console.log(params);
      if(params['action_page'] == 'singleCall'){
        // 指定singlecall页面
        if(params['method'] == 'pause'){
          // 本处为 A正在呼叫C、B暂停 所以记录三方通话Id
          this.multiCallId = params['call_id'];
          // 暂停通话
          this.pauseCall();
        }else if(params['method'] == 'reStart'){
          // 恢复通话
          this.restartCall();
        }else if(params['method'] == 'createRoom'){
          this.userCAgreeFlg = true;
          // 先和第三方进入room通话
          Dialog.close();
          this.doHangup();
        }else if(params['method'] == 'offLineCall'){
          this.sendMultiCallMsg();
        }else if(params['method'] == 'joinMultiCallRoom'){
          this.$router.push({
            path: "/roomConversation",
            query: { id: params['roomId'], room_id: params['roomId']
              ,mikeOpen:this.pauseCallValue.audio,cameraOpen:this.pauseCallValue.video
              ,multiCall:true
            },
          });
        }

      }
    },
    changeZoomFlg(){
      if(!this.frame){
        // 必须是speaker模式
        this.zoomFlg = !this.zoomFlg;
      }
    },
    handleClick(event) {
      if (this.clickTimer === null) {
        this.clickTimer = setTimeout(() => {
          this.clickTimer = null;
          this.clickScreen(); // 单击处理
        }, 200);
      } else {
        clearTimeout(this.clickTimer);
        this.clickTimer = null;
        this.changeZoomFlg(); // 双击处理
        event.stopPropagation();
      }
    },
    createMultiRoomId() {
      let now = new Date();
      // 获取当前的时、分、秒，并格式化为两位数
      let hours = now.getHours().toString().padStart(2, '0');
      let minutes = now.getMinutes().toString().padStart(2, '0');
      let seconds = now.getSeconds().toString().padStart(2, '0');

      // 拼接固定前缀 "2"，传入数字，以及当前时间的 "HHMMSS" 部分
      return '2' + hours + minutes + seconds +randNumStr(3);
    },
    chooseUser(item){
      console.log("选择",item);
      this.multiCallUser = item;
      this.multiCallUserId = item.account_id;
    },
    changeUserModelShow(value){
      this.userModelShow = value;
    },
    async showUserModel(){
      let res = await FindSameTeamMembers();
      if (res && res.data.code >= 0) {
        let userInfo = JSON.parse(localStorage.getItem(process.env.VUE_APP_USER_KEY));
        this.sameTeamDoctorList = res.data.data.filter(item =>
            item.account_id !== userInfo.login_account_id && item.account_id !== this.remoteuser[2]
        );
        this.changeUserModelShow(true);
      } else {
        Toast.fail("リストの取得に失敗しました");
      }
    },
    cancelUserModel(){
      this.changeUserModelShow(false);
      this.multiCallUser = null;
      this.multiCallUserId = null;
    },
    sendMultiCallMsg(){
      // 发送唤醒服务
      let service_msg = {to_service: [this.multiCallUser.account_id+"_service"],};
      doSend(JSON.stringify(service_msg));
      let userInfo = JSON.parse(localStorage.getItem(process.env.VUE_APP_USER_KEY));
      let multiCallMsg = {call_id: this.multiCallId,send_type:"multiCall",method: "multiCall"
        ,type:"apply",to_users:[this.multiCallUser.account_id]
        ,call_user : userInfo.login_account_id ,call_user_name : userInfo.name};
      doSend(JSON.stringify(multiCallMsg));
    },
    async confirmUserModel(){
      let res;
      if(this.multiCallUser.type == '4'){
        // 医生
        res = await GetDoctorDetail(this.multiCallUser.account_id);
      }else if(this.multiCallUser.type == '5'){
        // 患者
        res = await GetPatientDetails(this.multiCallUser.account_id);
      }else{
        return;
      }
      // 呼叫用户C
      let user = res.data.data.detail;
      let type;
      if(user.online_status == 'online'){
        // 在线
        if (user.calling_status != "3" && user.calling_status != "6") {
          type = 'busy';
        }else{
          type = 'online';
        }
      }else{
        // 离线
        if (user.push_status != "can") {
          type = 'busy';
        }else{
          type = 'offline';
        }
      }
      if(type == 'busy'){
        // 无需拨打
        Dialog.alert({
          message: '現在通話中\n後ほどお掛け直しください',
          theme: 'round-button',
          confirmButtonText: 'キャンセル',
        });
        return;
      }
      this.changeUserModelShow(false);
      this.multiCallId = randPwd(32);
      this.multiCallInitiator = true;
      // 当前通话暂停
      this.pauseCall();
      let userInfo = JSON.parse(localStorage.getItem(process.env.VUE_APP_USER_KEY));
      if(type == 'online'){
        // 在线的话就发送websocket
        this.sendMultiCallMsg();
      }else if(type == 'offline'){
        console.log("离线");
        // 离线拨打
        pushMessage({
          to_user: this.multiCallUser.account_id,
          push_user: userInfo.name,
          call_type: 6,
          type :this.multiCallUser.type,
        });
        // 发送唤醒服务
        let service_msg = {to_service: [this.multiCallUser.account_id+"_service"],};
        doSend(JSON.stringify(service_msg));
      }
      // 等待接听
      Dialog.alert({
        message: '当通話保留\n新会話の通話待ち中',
        theme: 'round-button',
        confirmButtonText: 'キャンセル',
      }).then(() => {
        console.log("取消三方通话");
        // 通知C取消通话了
        let outTimeMsg = {call_id: this.multiCallId,send_type:"multiCall"
          ,type:"outTime",to_users:[this.multiCallUser.account_id]
          ,call_user : userInfo.login_account_id};
        doSend(JSON.stringify(outTimeMsg));
        if(type == 'offline'){
          // 离线需要修改logpush表
          changeMessageStatus({ to_user: userInfo.login_account_id }).then(
              () => {}
          );
        }
        // 恢复通话
        this.restartCall();
      });
    },
    pauseCall(){
      console.log("暂停通话");
      Dialog.close();
      if(this.multiCallInitiator){
        // 发送唤醒服务
        let service_msg = {to_service: [this.remoteuser[2]+"_service"],};
        doSend(JSON.stringify(service_msg));
        // 如果是发起人 需要通知通话对方也暂停
        let userInfo = JSON.parse(localStorage.getItem(process.env.VUE_APP_USER_KEY));
        let noticeMsg = {call_id: this.multiCallId,send_type:"multiCall",type:"notice",
          method:"pause",to_users:[this.remoteuser[2]],call_user:userInfo.login_account_id};
        console.log("通知对方暂停",noticeMsg);
        doSend(JSON.stringify(noticeMsg));
      }
      this.pauseCallValue = {video:this.controller_data.viShow,audio:this.controller_data.mkShow}
      if(this.controller_data.mkShow){
        this.changeShow('mike');
      }
      if(this.controller_data.viShow){
        this.changeShow('video');
      }
      // 放到最后 后续不可再调用开关麦克风摄像头
      this.multiCallFlg = true;
    },
    restartCall(){
      console.log("恢复通话");
      // 放到最前 之后要调用开关麦克风摄像头
      this.multiCallFlg = false;
      // 检测一下通话还是否存在 如果不在了 挂断电话
      if(!this.videocall){
        // janus已经结束 可以直接结束
        console.log("返回上一页面");
        this.$router.go(-1);
        return;
      }
      // 三方通话ID置空
      this.multiCallId = null;
      if(this.multiCallInitiator){
        // 发送唤醒服务
        let service_msg = {to_service: [this.remoteuser[2]+"_service"],};
        doSend(JSON.stringify(service_msg));
        // 如果是发起人 需要通知对方也恢复
        // 通知b恢复通话
        let noticeMsg = {call_id: this.multiCallId,send_type:"multiCall",type:"notice",
          method:"reStart",to_users:[this.remoteuser[2]],call_user:null};
        doSend(JSON.stringify(noticeMsg));
        // 发起人置空
        this.multiCallInitiator = false;
      }
      if(this.controller_data.mkShow !== this.pauseCallValue.audio){
        this.changeShow('mike');
      }
      if(this.controller_data.viShow !== this.pauseCallValue.video){
        this.changeShow('video');
      }
      this.pauseCallValue = {};
    },
    printNow(str){
      // console.error(new Date())
      console.log("now is at "+str)
    },
    janusReceiveMsg(data){
      console.log(data);
      // 远程操作
      if(data['method'] == "changeController"){
        // 开关摄像头
        if(data['changeCameraStatus'] != null){
          if(data['changeCameraStatus'] && !this.controller_data.viShow){
            this.changeShow("video");
            Toast("相手があなたのカメラを開けた");
          }else if (!data['changeCameraStatus'] && this.controller_data.viShow) {
            this.changeShow("video");
            Toast("相手はあなたのカメラを閉じました");
          }
        }
        // 开关麦克风
        if(data['changeAudioStatus'] != null){
          if(data['changeAudioStatus'] && !this.controller_data.mkShow){
            Toast("相手があなたのマイクを開けた");
            this.changeShow("mike");
          }else if (!data['changeAudioStatus'] && this.controller_data.mkShow) {
            Toast("相手はあなたのマイクを閉じました");
            this.changeShow("mike");
          }
        }
        // 切换前后置摄像头
        if(data['changeCameraRearStatus'] != null){
          if((data['changeCameraRearStatus'] && this.facingMode !=="environment")
              ||(data['changeCameraRearStatus'] && this.facingMode !=="user") ){
            Toast("相手があなたのカメラを切り替えました");
            this.changeCamera();
          }
        }
      }else if(data['method'] == "updateControllerStatus"){
        // 前后置摄像头
        if(data['cameraRear'] != undefined && data['cameraRear'] == 'user'){
          this.tool_value.checkedCameraRear = false;
        }else if(data['cameraRear'] == 'environment') {
          this.tool_value.checkedCameraRear = false;
        }
        // 摄像头
        if(data['checkedCamera'] != undefined && data['checkedCamera'] != undefined){
          this.printNow("set checkedCamera false or true");

          this.tool_value.checkedCamera = data['checkedCamera'];
        }
        // 麦克风
        if(data['checkedAudio'] != undefined && data['checkedAudio'] != undefined){
          this.tool_value.checkedAudio = data['checkedAudio'];
        }
      }else if(data['method'] == "audioToTextShow"){
        // 语音转文字对方显示
        this.setAudioText(data['text'])
      }else if(data['method'] == "doRecord"){
        // 对方开启录像
        this.isRecording = true;
        this.controller_data.checkedVideotape = !this.controller_data.checkedVideotape;
        this.recordDisable = true;
        this.doRecord(data);
      }else if (data["method"] == "finishRecord") {
        // 对方结束录像
        this.finishRecord();
      }else if(data["method"] == "changeShareStatus"){
        // 对方开启或关闭了屏幕共享
        console.log(data["status"]);
        this.remoteShareScreenStatus = data["status"];
      }
    },
    stopWebSpeech(){
      this.stopSpeechRecognition();
    },
    async startWebSpeech(){
      this.audioEndFlg = false;
      if(this.recognition){
        this.recognition.start();
      }else{
        let SpeechRecognition = window.SpeechRecognition || window.webkitSpeechRecognition;
        this.recognition = new SpeechRecognition();
        // 设置识别语言
        this.recognition.lang = 'ja-JP';
        // this.recognition.lang = 'zh-CN';
        // 设置连续识别
        this.recognition.continuous = true;
        // 返回临时结果
        this.recognition.interimResults = false;
        // 返回的可能匹配值的数量 默认值1
        this.recognition.maxAlternatives = 1;
        // 开始识别
        this.recognition.start();
        let userRet = await RefreshUserInfo();
        let userInfo = userRet.data.data.user;
        localStorage.setItem(process.env.VUE_APP_USER_KEY, JSON.stringify(userInfo));
        // 接收、处理结果
        this.recognition.onresult = (event) => {
          var last = event.results.length - 1;
          if(event.results[last][0].transcript && event.results[last][0].transcript !=""){
            let msg = {
              method:"audioToTextShow",
              text:userInfo.name + ":" + event.results[last][0].transcript,
            }
            this.setAudioText("自身:" + event.results[last][0].transcript)
            // 同步发送给对方
            this.videocall.data({
              text: JSON.stringify(msg),
              error: function () {console.log('エラー');},
              success: function () {},});
          }
        };
        this.recognition.onerror = (event)=>{
          console.log('エラー: ' + event.error);
        };
        this.recognition.onend = () => {
          if(!this.audioEndFlg){
            this.recognition.start();
          }
        };
      }
    },
    async changeShow(type) {
      if(this.multiCallFlg){
        Toast("通話が一時停止されています。しばらくしてから再度お試しください");
        return;
      }
      if ("mike" == type) {
        this.controller_data.mkShow = !this.controller_data.mkShow;
        this.videocall.send({message: { request: "set", audio: this.controller_data.mkShow }});
        // 语音识别检测
        if(this.recognition){
          if(!this.controller_data.mkShow){
            // 麦克风关闭 同步关闭语音识别
            this.stopWebSpeech();
          }else{
            // 麦克风开启时 恢复语音识别
            this.startWebSpeech();
          }
        }
        this.sendAudioAndVideoStatus(null,this.controller_data.mkShow,null);
      } else if ("video" == type) {
        if(this.permissionError){
          // 摄像头获取失败 直接false
          Toast("カメラ権限が異常です。");
          return;
        }
        this.controller_data.viShow = !this.controller_data.viShow;
        // janus变更状态
        this.videocall.send({message: { request: "set", video: this.controller_data.viShow },});
        this.sendAudioAndVideoStatus(this.controller_data.viShow,null,null);
        // message变更状态
        if (this.controller_data.viShow) {
          JQuery("#myvideo").get(0).srcObject = this.sendStream;
        } else {
          JQuery("#myvideo").get(0).srcObject = null;
        }
      }
    },
    async initAudioAndVideo() {
      let userRet = await RefreshUserInfo();
      if (this.callReturnPage) {
        return false;
      }
      console.log("initAudioAndVideo end")
      this.userRet = userRet
      let userInfo = userRet.data.data.user;
      localStorage.setItem(process.env.VUE_APP_USER_KEY, JSON.stringify(userInfo));
      let video = false;
      let audio = false;
      // 患者端默认摄像头
      if (userInfo.type === "5") {
        if (userInfo.camera_flg === "1") {
          video = true;
          if(this.$route.query.videoOrAudioCall==="audio"){
            video = false;
          }
        }
        if (userInfo.audio_flg === "1") {
          audio = true;
        }
      }else{
        // 医生部分
        if(this.controller_data.userType == 'answerUser'){
          // 受话时 默认都开
          video = true;
          if(this.$route.query.videoOrAudioCall==="audio"){
            video = false;
          }
          audio = true;
        }else{
          // 打电话时看前置页面选择的值
          video = this.$route.query.cameraOpen === 'true';
          audio = this.$route.query.mikeOpen === 'true';
        }
      }
      this.controller_data.viShow =  video;
      this.controller_data.mkShow =  audio;

      // 自身画面表示（スピーカービューのみ有効）
      let selfViewEnabled = true;
      if (userInfo.self_view_flg !== undefined && userInfo.self_view_flg !== null && userInfo.self_view_flg !== "") {
        selfViewEnabled = Number(userInfo.self_view_flg) === 1;
      }
      this.tool_value.checkedSelfView = selfViewEnabled;
      this.back_tool_value.checkedSelfView = selfViewEnabled;
      if (!this.frame && !selfViewEnabled) {
        this.my_video_show = false;
        this.showMyvideoButton = false;
      }
      return true;
    },
    setAudioAndVideo(){
      this.videocall.send({message: { request: "set", audio: this.controller_data.mkShow, video: this.controller_data.viShow }});
      if (this.controller_data.viShow) {
        JQuery("#myvideo").get(0).srcObject = this.sendStream;
      } else {
        JQuery("#myvideo").get(0).srcObject = null;
      }
      setTimeout(() => {
        this.sendAudioAndVideoStatus(this.controller_data.viShow,this.controller_data.mkShow,null);
      }, 1500);
    },
    sendAudioAndVideoStatus(video,audio,facingMode){
      // 同步发送给对方
      let msg = {
        "method":"updateControllerStatus",
      }
      if(video!=null){
        msg["checkedCamera"] = video;
      }
      if(audio!=null){
        msg["checkedAudio"] = audio;
      }
      if(facingMode!=null){
        msg["cameraRear"] = facingMode;
      }
      this.videocall.data({
        text: JSON.stringify(msg),
        error: function () {console.log('エラー');},
        success: function () {},});
    },
    async initPage(){
      this.resetCallSetupState();
      this.callInitRetryCount = 0;
      this.controller_data.userType = this.$route.query.userType;
      this.controller_data.videoOrAudioCall = this.$route.query.videoOrAudioCall;
      this.controller_data.callType = this.$route.query.callType;
      console.log(this.controller_data);
      // 通话界面样式
      if(this.controller_data.videoOrAudioCall == 'video'){
        this.footerItem = false;
        this.checkedShow = false;
      }else{
        this.footerItem = true;
        this.my_video_show = false;
      }
      // 初始化摄像头麦克风
      let initialized = false;
      try {
        initialized = await this.initAudioAndVideo();
      } catch (error) {
        console.log("initAudioAndVideo failed", error);
        if (!this.callReturnPage) {
          Toast.fail("接続できませんでした。");
          this.finalizeAbnormalEnd(true);
        }
        return;
      }
      if (!initialized || this.callReturnPage) {
        return;
      }
      this.startCallSetupMonitor();

      console.log("initJanus");

      let userInfo = this.userRet.data.data.user;

      if(this.$route.query.userType == "answerUser"){
        // 接听电话者在外部定义好了id
        this.registerName = this.$route.query.answerUser;
        console.log("initJanus");
        this.initJanus();
      }else{
        // 打电话人获取id
        let registerName = process.env.VUE_APP_JANUS_USERNAME + userInfo.type + "_" + userInfo.login_account_id + "_" + randNumStr(4) + "_" + userInfo.name;
        this.registerName = registerName;
        this.controller_data.answerUser = this.$route.query.answerUser;
        setTimeout(() => {
          if (this.callReturnPage) {
            return;
          }
          this.printNow("caller initPage")
          this.initJanus();
        }, 10);
      }
      // 检测是否设置了通话上限时间
      if(userInfo.call_time_limit == '1'){
        // 提前30秒提示
        if(this.callLimitToastTimeOut){
          clearTimeout(this.callLimitToastTimeOut)
        }
        this.callLimitToastTimeOut = setTimeout(()=>{
          this.$dialog.alert({
            confirmButtonText:'閉じる',
            message: '通話は30秒後に切断されます。',
          }).then(() => {
          })
          setTimeout(() => {
            this.$dialog.close();
          }, 5000);
          if(this.callLimitHangTimeOut){
            clearTimeout(this.callLimitHangTimeOut)
          }
          this.callLimitHangTimeOut = setTimeout(()=>{
            this.doHangup();
          },30000);
        },Number(userInfo.call_time_limit_time) * 60 * 1000 -30000);
      }


    },
    initJanus() {
      if (this.callReturnPage) {
        return;
      }
      this.stopPeerLookup();
      this.callOfferRequested = false;
      this.answerRequestHandled = false;
      this.localHangupPending = false;
      this.waitLocalStream = true;
      this.runIosAudioSessionAction("prepareForCall");
      this.destroyCallSession();
      const attemptId = ++this.callSessionAttemptId;
      const mediaRequestId = ++this.callMediaRequestId;
      //1.janus初期化
      Janus.init({
        debug: "all",
        callback: () => {
          if (!this.isCurrentCallSession(attemptId)) {
            return;
          }
          console.log("init ok");
          if (!Janus.isWebrtcSupported()) {
            alert("No WebRTC support... ");
            return;
          }
          this.startInitJanus(attemptId);
        },
      });
      this.sendStreamInitPromise = this.getSendStream(
        this.controller_data.videoOrAudioCall == 'video' ? true:false,
        mediaRequestId
      );
    },
    startInitJanus(attemptId) {
      if (!this.isCurrentCallSession(attemptId)) {
        return;
      }
      //创建session
      let serverStunUrl='turn:35.78.136.103:3478';
      let serverUserName='lqf';
      let serverUserCredential='123456';
      const host = window.location.host;
      if (host.indexOf('localhost') !== -1 || host.indexOf('tmp') !== -1) {
        serverStunUrl='turn:43.154.16.102:3478';
      } else if (host.indexOf('stg') !== -1) {
        serverStunUrl='turn:52.194.48.148:3478';
        serverUserName='test';
        serverUserCredential='12345678';
      }

      let iceServers=[{urls: serverStunUrl,username: serverUserName, credential: serverUserCredential}];


      var localTracks = {},
          remoteTracks = {},
          remoteTracks2 = {};
      let session = null;
      session = new Janus({
        server: this.janus_server,
        iceServers: iceServers,
        success: () => {
          if (!this.isCurrentCallSession(attemptId, session)) {
            destroyJanusSession(session);
            return;
          }
          this.printNow("init Janus ok")
          session.attach({
            plugin: "janus.plugin.videocall",
            opaqueId: this.opaqueId,
            success: (pluginHandle) => {
              if (!this.isCurrentCallSession(attemptId, session)) {
                pluginHandle.detach?.();
                return;
              }
              this.videocall = markRaw(pluginHandle);
              //注册用户名
              var register = { request: "register", username: this.registerName };
              this.videocall.send({ message: register });
            },
            error: (error) => {
              if (!this.isCurrentCallSession(attemptId, session)) {
                return;
              }
              Janus.error("  -- Error attaching plugin...", error);
              if (!this.showHangup) {
                this.handleCallSetupFailure("attach_plugin_failed");
                return;
              }
              if (!this.handleCallRuntimeFailure()) {
                this.finalizeAbnormalEnd(true);
              }
            },
            consentDialog: (on) => {
              Janus.debug("Consent dialog should be " + (on ? "on" : "off") + " now");
              if (on) {
                // Darken screen and show hint
              } else {
                // Restore screen
              }
            },
            iceState: (state) => {
              if (!this.isCurrentCallSession(attemptId, session)) {
                return;
              }
              Janus.log("ICE state changed to " + state);
              if (state === "connected" || state === "completed") {
                this.clearConnectionIssue();
              }
              if (state === "disconnected" || state === "failed" || state === "closed") {
                this.markConnectionIssue();
                this.scheduleCallStatusCheck(1500, true);
              }
            },
            mediaState: (medium, on, mid) => {
              Janus.log("Janus " + (on ? "started" : "stopped") + " receiving our " + medium + " (mid=" + mid + ")");
            },
            webrtcState: (on) => {
              if (!this.isCurrentCallSession(attemptId, session)) {
                return;
              }
              Janus.log("Janus says our WebRTC PeerConnection is " + (on ? "up" : "down") + " now");
              if (on) {
                this.clearConnectionIssue();
              }
              if (!on) {
                this.markConnectionIssue();
                this.scheduleCallStatusCheck(1500, true);
              }
            },
            slowLink: (uplink, lost, mid) => {
              Janus.warn("Janus reports problems " + (uplink ? "sending" : "receiving") + " packets on mid " + mid + " (" + lost + " lost packets)");
            },
            onmessage: (msg, jsep) => {
              if (!this.isCurrentCallSession(attemptId, session)) {
                return;
              }
              this.jsep = jsep;
              Janus.debug(" ::: Got a message :::", msg);
              var result = msg["result"];
              if (result) {
                console.log("get list ok");
                if (result["list"]) {
                  var list = result["list"];
                  Janus.debug("Got a list of registered peers:", list);
                  this.printNow("Got a list of registered peers:")
                  this.printNow(JSON.stringify(list))

                  let answerUserHasRegistered = false
                  list.forEach((listItem)=>{
                    if(listItem === this.controller_data.answerUser){
                      //docall
                      answerUserHasRegistered= true;
                    }
                  })

                  if(answerUserHasRegistered){
                    this.printNow("answerUserHasRegistered!!")
                    if(this.controller_data.userType == 'callUser' && !this.callOfferRequested){
                      this.callOfferRequested = true;
                      this.stopPeerLookup();
                      this.doCall(this.controller_data.answerUser,this.controller_data.videoOrAudioCall);
                    }
                  }else{
                    if(this.controller_data.userType == 'callUser'){
                      this.schedulePeerLookup()
                    }
                  }

                } else if (result["event"]) {
                  var event = result["event"];
                  if (event === "registered") {
                    //注册成功时
                    this.registered(result);
                  } else if (event === "calling") {
                    Janus.log("Waiting for the peer to answer...");
                    this.printNow("calling...waiting...")
                  } else if (event === "incomingcall") {
                    Janus.log("Incoming call from " + result["username"] + "!");
                    this.printNow("incomingcall...")
                    // 接到电话

                    this.haveCall= true

                    this.remoteuser = this.splitMethod(this.escapeXmlTags(result["username"]), "_", 5);
                    if (!this.answerRequestHandled) {
                      this.answerRequestHandled = true;
                      this.answerCall(jsep, this.controller_data.videoOrAudioCall);
                    }
                  } else if (event === "accepted") {
                    // 接通之后开放通话控制，建连中的结束按钮始终可用。
                    this.showHangup=true;
                    this.completeCallSetupIfReady();
                    this.stopPeerLookup();
                    this.touchPeerHeartbeat();
                    this.startHeartbeatMonitor();
                    this.startCallStatusMonitor(this.stableCallStatusMonitorMs, true);
                    this.setAudioAndVideo();
                    var peer = this.escapeXmlTags(result["username"]);
                    if (!peer) {
                      Janus.log("Call started! peer is null");
                    } else {
                      Janus.log(peer + " accepted the call!");
                      this.remoteuser = this.splitMethod(peer, "_", 5);
                    }
                    // Video call can start
                    if (jsep) this.videocall.handleRemoteJsep({ jsep: jsep });
                  } else if (event === "update") {
                    console.log("进入update");
                  } else if (event === "hangup") {
                    // 挂断电话
                    if(this.videocall){
                      this.videocall.hangup()
                    }
                    this.handlePeerHangupEvent("peer_hangup")
                  } else if (event === "simulcast") {
                    console.log("进入simulcast");
                  }
                }
              } else {
                // FIXME Error?
                var error = msg["error"];
                if (error.indexOf("already taken") >= 0) {}
                if(this.videocall){
                  this.videocall.hangup();
                }
                if (!this.showHangup) {
                  this.handleCallSetupFailure("videocall_message_error");
                  return;
                }
                if (!this.handleCallRuntimeFailure()) {
                  this.finalizeAbnormalEnd(true);
                }
              }
            },
            onlocaltrack: (track, on) => {
              if (!this.isCurrentCallSession(attemptId, session)) {
                if (on) {
                  track.stop?.();
                }
                return;
              }
              console.log("onlocaltrack");
              this.printNow("onlocaltrack")

              if(track.readyState =="ended" && this.tool_value.checkedShareScreen){
                //close
                this.shareScreen()
                return;
              }
              var trackId = track.id.replace(/[{}]/g, "");
              if (!on) {
                // Track removed, get rid of the stream and the rendering
                delete localTracks[trackId];
                if (track.kind === "audio") {
                  this.localAudioTrack = null;
                } else {
                  this.localVideoTrack = null;
                  Janus.attachMediaStream(JQuery("#myvideo").get(0), null);
                  const activeVideoTrack = this.getMediaTrack(this.sendStream, "video");
                  if (activeVideoTrack?.id === track.id) {
                    this.stopMediaTarget(this.sendStream);
                    this.sendStream = null;
                  }
                }
                return;
              }
              // If we're here, a new track was added
              var stream = localTracks[trackId];
              if (stream) {
                // We've been here already
                return;
              }
              if (track.kind === "audio") {
                this.localAudioTrack = track;
              } else {
                this.localVideoTrack = track;
                stream = new MediaStream([track]);
                localTracks[trackId] = stream;
                const previousVideoTrack = this.getMediaTrack(this.sendStream, "video");
                if(previousVideoTrack && previousVideoTrack.id !== track.id){
                  this.stopMediaTarget(this.sendStream);
                }
                this.sendStream = stream;
                if(this.controller_data.viShow){
                  Janus.attachMediaStream(JQuery("#myvideo").get(0), this.sendStream);
                }else{
                  Janus.attachMediaStream(JQuery("#myvideo").get(0), null);
                }
              }
            },
            onremotetrack: (track, mid, on) => {
              if (!this.isCurrentCallSession(attemptId, session)) {
                return;
              }
              console.log("onremotetrack");
              this.printNow("onremotetrack")
              if (!on) {
                if (track.kind === "audio") {
                  this.remoteAudioTrackActive = false;
                  delete remoteTracks2[mid];
                  Janus.attachMediaStream(JQuery("#remoteaudio").get(0), null);
                } else {
                  this.remoteVideoTrackActive = false;
                  this.tool_value.checkedCamera = false;
                  delete remoteTracks[mid];
                  Janus.attachMediaStream(JQuery("#remotevideo").get(0), null);
                }
                this.evaluateRemoteMediaState();
                return;
              }
              this.markCallMediaConnected();
              var stream;
              if (track.kind === "audio") {
                this.remoteAudioTrackActive = true;
                this.bindRemoteTrackEvents(track, "audio", attemptId, session);
                stream = new MediaStream([track]);
                remoteTracks2[mid] = stream;
                const remoteAudioElement = JQuery("#remoteaudio").get(0);
                Janus.attachMediaStream(remoteAudioElement, stream);
                if (remoteAudioElement) {
                  remoteAudioElement.volume = 1;
                  remoteAudioElement.play().catch((error) => {
                    console.log("remoteaudio play failed:", error);
                  });
                }
              } else {
                this.remoteVideoTrackActive = true;
                this.bindRemoteTrackEvents(track, "video", attemptId, session);
                this.printNow("set checkedCamera");
                this.tool_value.checkedCamera = true;
                // New video track: create a stream out of it
                stream = new MediaStream([track]);
                remoteTracks[mid] = stream;
                Janus.attachMediaStream(JQuery("#remotevideo").get(0), stream);
                if (this.bitrateTimer == null) {
                  this.bitrateTimer = setInterval(() => {
                    if (!this.$store.state.isCalling) {
                      return;
                    }
                    // Display updated bitrate, if supported
                    var bitrate = this.videocall.getBitrate();
                    this.curbitrate = bitrate;
                  }, 1000);
                }
              }
              this.clearConnectionIssue();
            },
            ondataopen: (data) => {
              if (!this.isCurrentCallSession(attemptId, session)) {
                return;
              }
              Janus.log("The DataChannel is available!");
              this.markCallMediaConnected();
              this.dataChannelOpen = true;
              this.touchPeerHeartbeat();
              this.startHeartbeatMonitor();
            },
            ondata: (data) => {
              if (!this.isCurrentCallSession(attemptId, session)) {
                return;
              }
              // 收到消息
              const parsedData = JSON.parse(data);
              this.touchPeerHeartbeat();
              if (this.handleHeartbeatMessage(parsedData)) {
                return;
              }
              this.janusReceiveMsg(parsedData);
              this.printNow("on data")
              Janus.debug("We got data from the DataChannel!", data);
            },
            oncleanup: () => {
              Janus.log(" ::: Got a cleanup notification :::");
              if (!this.isCurrentCallSession(attemptId, session)) {
                return;
              }
              const localHangup = this.localHangupPending;
              const retryCount = this.callInitRetryCount;
              this.destroyCallSession(session, false);
              setTimeout(() => {
                if (this.callReturnPage) {
                  return;
                }
                if (localHangup || this.clickHangupFlg) {
                  this.returnPage({ skipRootLog: true });
                } else if (!this.showHangup) {
                  if (retryCount === this.callInitRetryCount) {
                    this.handleCallSetupFailure("janus_webrtc_cleanup");
                  }
                } else if (!this.handleCallRuntimeFailure()) {
                  this.finalizeAbnormalEnd(true);
                }
              }, 0);
            },
          });
        },
        error: (error) => {
          if (!this.isCurrentCallSession(attemptId, session)) {
            destroyJanusSession(session);
            return;
          }
          Janus.error(error);
          if (!this.showHangup) {
            this.handleCallSetupFailure("janus_session_error");
            return;
          }
          if (!this.handleCallRuntimeFailure()) {
            this.finalizeAbnormalEnd(true);
          }
        },
        destroyed:  ()=> {
          if (!this.isCurrentCallSession(attemptId, session)) {
            return;
          }
          this.janus = null;
          this.videocall = null;
          if (this.callReturnPage || this.clickHangupFlg) {
            this.returnPage({ skipRootLog: true });
            return;
          }
          if (!this.showHangup) {
            this.handleCallSetupFailure("janus_session_destroyed");
            return;
          }
          if (this.handleCallRuntimeFailure()) {
            return;
          }
          this.finalizeAbnormalEnd(true);
        },
      });
      this.janus = markRaw(session);
    },
    setAudioText(text){
      this.audioText.push(text);
    },
    changeView(type){
      // 默认的是true
      this.changeViewShow = true;
      if(type == 'speaker'){
        this.frame = false;
        if (this.tool_value.checkedSelfView) {
          this.my_video_show = true;
          this.showMyvideoButton = false;
        } else {
          this.my_video_show = false;
          this.showMyvideoButton = false;
        }
      }else{
        this.frame = true;
        this.my_video_show = true;
        this.showMyvideoButton = false;
        // 不需要缩放
        this.zoomFlg = false;
      }
    },
    changeFrame() {
      this.changeViewShow = !this.changeViewShow;
    },
    doCall(call_name, type) {
      let video = true;
      if (type == "audio") {
        video = false;
      }
      this.remoteuser = this.splitMethod(call_name, "_", 5);
      this.createVideo("createOffer", call_name, video);
      this.printNow("doCall")
    },
    async getSendStream(video, requestId = this.callMediaRequestId){
      if(this.sendStream){
        this.stopMediaTarget(this.sendStream);
        this.sendStream = null;
      }
      let userRet = this.userRet;
      let user = userRet.data.data.user;
      localStorage.setItem(process.env.VUE_APP_USER_KEY, JSON.stringify(user));
      this.printNow("getUserMedia start")

      if(!video){
        // 语音拨打不需要获取音频
        this.printNow("audio call")
        this.waitLocalStream = false;
        this.sendStream = false;
      }else{
        let videoCheck = false;
        try {
          let mediaStream = await navigator.mediaDevices.getUserMedia({audio: false, video: true,});
          if (requestId !== this.callMediaRequestId) {
            Janus.stopAllTracks(mediaStream);
            return;
          }
          if (mediaStream && mediaStream.getVideoTracks().length > 0) {
            this.printNow("getUserMedia success");
            videoCheck = true;
            //已经获取到了本地的，后续不需要再等待
            this.waitLocalStream = false;
            let userInfo = JSON.parse(localStorage.getItem(process.env.VUE_APP_USER_KEY));
            console.log(userInfo);
            if(userInfo.background_flg == '1'){
              // 需要开启虚拟背景
              this.createCanvas(mediaStream,'img');
              this.sendStream = this.$refs.myCanvas.captureStream().getVideoTracks()[0];
              this.tool_value.checkedBackground = true;
            }else if(userInfo.background_flg == '2'){
              // 需要开启虚化背景
              this.createCanvas(mediaStream,'back');
              this.sendStream = this.$refs.myCanvas.captureStream().getVideoTracks()[0];
              this.tool_value.checkedBlurBackground = true;
            }else{
              this.sendStream = mediaStream;
            }
          }
          // 在这里处理成功获取的视频流
        } catch (error) {
          if (requestId !== this.callMediaRequestId) {
            return;
          }
          console.log(error);
          this.printNow("getUserMedia fail")
        }
        if(!videoCheck){
          this.permissionError=true;
          Toast("カメラ権限が異常です。");
          // 当作没有摄像头处理
          this.waitLocalStream = false;
          this.sendStream = false;
          this.controller_data.viShow = false;
        }
      }
    },
    async createVideo(type, call_name, video, answerJsep) {
      const attemptId = this.callSessionAttemptId;
      const requestId = this.callMediaRequestId;
      const videocall = this.videocall;
      if (this.sendStreamInitPromise) {
        await this.sendStreamInitPromise;
      }
      if (
        !this.isCurrentCallSession(attemptId) ||
        requestId !== this.callMediaRequestId ||
        !videocall ||
        videocall !== this.videocall
      ) {
        return;
      }
      if(this.waitLocalStream){
        if (!this.showHangup) {
          this.handleCallSetupFailure("local_stream_timeout");
        }
        return;
      }

      if (type == "createOffer") {
          const audioTrackConfig = await this.buildCallAudioTrackConfig(true, requestId);
          if (
            !this.isCurrentCallSession(attemptId) ||
            requestId !== this.callMediaRequestId ||
            videocall !== this.videocall
          ) {
            return;
          }
          // 拨打电话 姓名检测，不能有重复的
          videocall.createOffer({
            // We want bidirectional audio and video, plus data channels
            tracks: [
              audioTrackConfig,
              {
                type: "video",
                capture: this.getMediaTrack(this.sendStream, "video") || false,
                recv: video,
              },
              { type: "data" },
            ],
            success: (jsep) => {
              if (!this.isCurrentCallSession(attemptId) || videocall !== this.videocall) {
                return;
              }
              var body = { request: "call", username: call_name };
              videocall.send({ message: body, jsep: jsep });
            },
            error: (error) => {
              if (!this.isCurrentCallSession(attemptId) || videocall !== this.videocall) {
                return;
              }
              console.log(error);
              if (!this.showHangup) {
                this.handleCallSetupFailure("create_offer_failed");
                return;
              }
              if (!this.handleCallRuntimeFailure()) {
                this.finalizeAbnormalEnd(true);
              }
            },
          });
        } else if (type == "createAnswer") {
          const audioTrackConfig = await this.buildCallAudioTrackConfig(true, requestId);
          if (
            !this.isCurrentCallSession(attemptId) ||
            requestId !== this.callMediaRequestId ||
            videocall !== this.videocall
          ) {
            return;
          }
          videocall.createAnswer({
            jsep: answerJsep,
            tracks: [
              audioTrackConfig,
              {
                type: "video",
                capture: this.getMediaTrack(this.sendStream, "video") || false,
                recv: video,
              },
              { type: "data" },
            ],
            success: (jsep) => {
              if (!this.isCurrentCallSession(attemptId) || videocall !== this.videocall) {
                return;
              }
              Janus.debug("Got SDP!", jsep);
              var body = { request: "accept" };
              videocall.send({ message: body, jsep: jsep });
            },
            error: (error) => {
              if (!this.isCurrentCallSession(attemptId) || videocall !== this.videocall) {
                return;
              }
              Janus.error("WebRTC error:", error);
              if (!this.showHangup) {
                this.handleCallSetupFailure("create_answer_failed");
                return;
              }
              if (!this.handleCallRuntimeFailure()) {
                this.finalizeAbnormalEnd(true);
              }
            },
          });
        }
    },
    answerCall(jsep, type) {
      let video = true;
      if (type == "audio") {
        video = false;
      }
      this.createVideo("createAnswer", "", video, jsep);
    },
    getCurRegisteredUserList(){
      if (!this.videocall || this.callReturnPage || this.showHangup) {
        return;
      }
      this.videocall.send({ message: { request: "list" } });
    },
    // 注册成功
    registered(result) {
      console.log("registered ok");
      this.myuser = this.splitMethod(this.escapeXmlTags(result["username"]), "_", 5);
      Janus.log("Successfully registered as " + this.escapeXmlTags(result["username"]) + "!");
      if (this.controller_data.userType == 'callUser') {
        this.peerLookupAttempt = 0;
        this.getCurRegisteredUserList();
      }
    },
    splitMethod(str, splitStr, len) {
      let ret = [];
      let other = [];
      let list = str.split(splitStr);
      for (let i = 0; i < list.length; i++) {
        if (i < len - 1) {
          ret.push(list[i]);
        } else {
          other.push(list[i]);
        }
      }
      if (other.length > 0) {
        ret.push(other.join(splitStr));
      }
      return ret;
    },
    escapeXmlTags(value) {
      if (value) {
        var escapedValue = value.replace(new RegExp("<", "g"), "&lt");
        escapedValue = escapedValue.replace(new RegExp(">", "g"), "&gt");
        return escapedValue;
      }
    },
    clickMyvideoButton() {
      // 再表示按钮点击事件
      if (!this.frame && !this.tool_value.checkedSelfView) {
        return;
      }
      this.showMyvideoButton = false;
      this.my_video_show = true;
    },
    colseMyNameShow() {
      if (!this.frame && !this.tool_value.checkedSelfView) {
        return;
      }
      this.my_video_show = false;
      this.showMyvideoButton = true;
    },
    clickScreen() {
      // 点击屏幕隐藏和显示头部和底部工具栏
      if (!this.showHangup) {
        return;
      }
      this.headerAndFooter = !this.headerAndFooter;
    },
    clickHangup(){
      this.clickHangupFlg = true;
      this.doHangup();
    },
    doHangup() {
      if (this.callReturnPage) {
        return;
      }
      this.localHangupPending = true;
      this.saveCurrentCallEndLog();
      const videocall = this.videocall;
      if (videocall) {
        try {
          videocall.send({ message: { request: "hangup" } });
          videocall.hangup();
        } catch (error) {
          console.log("doHangup Janus cleanup failed", error);
        }
      }
      this.returnPage({ skipRootLog: true })
    },
    returnPage({ skipRootLog = false } = {}){
      //用于点击终了时，返回到上一个页面。
      //异常终了时，也需要返回
      this.connectionIssueDetected = false;
      this.connectionLostPending = false;
      this.connectionIssueStartedAt = 0;
      this.hideConnectionIssueOverlay();
      this.remoteAudioTrackActive = false;
      this.remoteVideoTrackActive = false;
      this.callMediaConnected = false;
      this.stopCallSetupMonitor();
      this.stopPeerLookup();
      this.clearCallStatusCheckTimer();
      this.stopHeartbeatMonitor();

      if(this.callReturnPage){
        return
      }

      //正常结束。刷新之后将会返回到上一级页面
      this.$store.commit("saveInCallingPage", false);

      //只调用一次
      this.callReturnPage = true
      this.skipBeforeUnmountHangup = true;
      this.destroyCallSession();

      if (this.isRecording) {
        this.isRecording = false
        this.$root.saveVideoRecordLog("recordStop",null,this.record_filename,1);
      }
      this.stopLocalMediaStreams();
      this.runIosAudioSessionAction("restoreAfterCall", 300);

      if(!skipRootLog && !this.endCallLogSaved){
        this.$root.saveEndCallMsg();
      }
      this.$root.resetPage();


      if (this.bitrateTimer !== null) {
        clearInterval(this.bitrateTimer);
        this.bitrateTimer = null;
        this.curbitrate = "";
      }
      if(!this.remoteuser){
        console.log("返回上一页面");
        this.$router.go(-1);
        return;
      }
      this.multiCallWaitUser = this.remoteuser[2];
      this.multiCallWaitUserType = this.remoteuser[1];
      this.remoteuser = null;

      this.checkPageAndDoSome();
    },
    checkPageAndDoSome(){
      if(this.$route.path =='/singleCall'){
        console.log("callback to last page")
        if(!this.clickHangupFlg && this.multiCallFlg ){
          // !this.clickHangupFlg 不是手动挂断
          // 正在三方通话的等待期间 1：C同意了、需要进入room 2：B挂断了、此时A还在拨打中
          if(this.multiCallInitiator && this.userCAgreeFlg){
            console.log("发起者需要进入room");
            // 如果是发起人，直接进入room
            let userInfo = JSON.parse(localStorage.getItem(process.env.VUE_APP_USER_KEY));
            let roomId = this.createMultiRoomId();
            // 发送唤醒服务
            let service_msg = {to_service: [this.multiCallUser.account_id+"_service"],};
            doSend(JSON.stringify(service_msg));
            // 需要将roomId发送给第三方通话者
            let multiCallMsg = {call_id: this.multiCallId,send_type:"multiCall",type: "joinRoom"
              ,roomId:roomId,to_users:[this.multiCallUser.account_id],call_user : userInfo.login_account_id};
            doSend(JSON.stringify(multiCallMsg));
            //跳转到room画面
            this.$router.push({
              path: "/roomConversation",
              query: { id: roomId, room_id: roomId,mikeOpen:this.pauseCallValue.audio
                ,cameraOpen:this.pauseCallValue.video,multiCallWaitUser:this.multiCallWaitUser
                ,multiCallWaitUserType:this.multiCallWaitUserType,multiCall:true},
            });
          }else{
            // 两种情况 1：用户B在等待，2：A在呼叫C的过程中、B挂断了
            console.log("在当前页面继续等待");
          }
        }else{
          console.log("返回上一页面");
          this.$router.go(-1);
        }
      }
    },
    async changeCamera(){
      if(this.permissionError){
        // 摄像头获取失败 直接false
        Toast("カメラ権限が異常です。");
        return;
      }
      // 左上角旋转摄像头
      if(this.controller_data.viShow){
        // 前置后置初始化
        if(this.facingMode == 'user'){
          this.facingMode = 'environment';
        }else{
          this.facingMode = 'user';
        }
        if (this.sendStream) {
          this.stopMediaTarget(this.sendStream);
        }
        // 获取摄像头
        // let newStream = await navigator.mediaDevices.getUserMedia({ video: { facingMode: { exact: this.facingMode } } })
        let newStream = await navigator.mediaDevices.getUserMedia({ video: { facingMode:this.facingMode } })
          .catch((error) => {
            // this.doHangup();
            Toast("カメラ権限が異常です。");
            return;
          });
        if(this.tool_value.checkedBackground){
          // 开启虚拟背景
          this.createCanvas(newStream,'img');
          this.videocall.createOffer({tracks: [{ type: 'video', replace: true, capture: this.$refs.myCanvas.captureStream().getVideoTracks()[0] }],});
        }else if (this.tool_value.checkedBlurBackground){
          // 开启模糊背景
          this.createCanvas(newStream,'back');
          this.videocall.createOffer({tracks: [{ type: 'video', replace: true, capture: this.$refs.myCanvas.captureStream().getVideoTracks()[0] }],});
        }else{
          this.stopCanvas();
          this.videocall.createOffer({tracks: [{ type: 'video', replace: true, capture: newStream.getVideoTracks()[0] }],});
        }
        // 因为有远程操作摄像头功能，所以要同步更新通话对方的控件
        let userInfo = JSON.parse(localStorage.getItem(process.env.VUE_APP_USER_KEY));
        if(userInfo.type === "5"){
          this.sendAudioAndVideoStatus(null,null,this.facingMode)
        }
      }
    },
    async createCanvas(stream, type) {
      console.log("ttttttttttttttttttttttttttttttttttttttttt");
      await this.stopCanvas();
      this.canvasSourceStream = stream;
      let user = JSON.parse(localStorage.getItem(process.env.VUE_APP_USER_KEY));
      this.context = this.$refs.myCanvas.getContext("2d");

      const selfieSegmentation = new SelfieSegmentation({
        locateFile: (file) => `https://cdn.jsdelivr.net/npm/@mediapipe/selfie_segmentation/${file}`,
      });
      selfieSegmentation.setOptions({ modelSelection: 0 });

      this.image = new Image();
      this.image.onload = () => {
        console.log("imgload!!!!!!!!!!!!!!!!!!!");
        if (type === 'img') {
          selfieSegmentation.onResults(this.handleSegmentationResults);
        } else {
          selfieSegmentation.onResults(this.handleSegmentationResults2);
        }
        const videoElement = JQuery("#soucevideo").get(0);

        Janus.attachMediaStream(videoElement, stream);
        videoElement.muted = "muted";

        let isSizeSet = false;
        videoElement.removeEventListener("playing", videoElement.playingListener);
        videoElement.playingListener = async  () => {
          console.log("playing!!!!!!");
          if (this.rafId) {
            cancelAnimationFrame(this.rafId);
            this.rafId = null;
          }
          var soucevideo = videoElement;
          if (!isSizeSet && soucevideo.videoWidth > 0 && soucevideo.videoHeight > 0) {
            this.$refs.myCanvas.width = soucevideo.videoWidth;
            this.$refs.myCanvas.height = soucevideo.videoHeight;
            this.image.width = soucevideo.videoWidth;
            this.image.height = soucevideo.videoHeight;
            isSizeSet = true;
          }
          let lastTime = performance.now();
          const minFrameInterval = 1000 / 15;
          const getFrames = async () => {
            if (!this.context || !selfieSegmentation) {
              return;
            }
            const now = performance.now();
            if (now - lastTime >= minFrameInterval) {
              console.log("test");
              await selfieSegmentation.send({ image: soucevideo });
              lastTime = now;
            }
            this.rafId = requestAnimationFrame(getFrames);
          };
          await getFrames();
        };
        videoElement.addEventListener("playing", videoElement.playingListener);
        videoElement.play();
      };
      if (user.backgroundpath) {
        console.log('111111');
        this.image.src = process.env.NODE_ENV !== "development" ? "getBackGroundImage/" + user.backgroundpath
            : "api/getBackGroundImage/" + user.backgroundpath;
      } else {
        console.log('22222222');
        this.image.src = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAUAAAAFCAIAAAACDbGyAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAB3RJTUUH4wQFACsJ9b/0CwAAAA1JREFUGNNjYGBg+E+A8e/H4IIJZ2BgYAQA20BkOQZiUjQAAAAASUVORK5CYII=";
      }
    },
    // 虚拟背景
    handleSegmentationResults(results) {
      // 绘制画像
      // Prepare the new frame
      this.context.save();
      this.context.clearRect(0, 0, this.$refs.myCanvas.width, this.$refs.myCanvas.height);
      this.context.drawImage(results.segmentationMask, 0, 0, this.$refs.myCanvas.width, this.$refs.myCanvas.height);

      // 计算背景图片的尺寸和位置，以便其占满整个视频区域
      const canvasAspectRatio = this.$refs.myCanvas.width / this.$refs.myCanvas.height;
      const imageAspectRatio = this.image.width / this.image.height;
      let drawWidth, drawHeight;
      if (canvasAspectRatio > imageAspectRatio) {
        drawWidth = this.$refs.myCanvas.width;
        drawHeight = drawWidth / imageAspectRatio;
      } else {
        drawHeight = this.$refs.myCanvas.height;
        drawWidth = drawHeight * imageAspectRatio;
      }
      const offsetX = (this.$refs.myCanvas.width - drawWidth) / 2;
      const offsetY = (this.$refs.myCanvas.height - drawHeight) / 2;

      // Only overwrite existing pixels.
      this.context.globalCompositeOperation = "source-out";
      this.context.drawImage(this.image, offsetX, offsetY, drawWidth, drawHeight);
      this.context.globalCompositeOperation = "destination-atop";
      this.context.drawImage(results.image, 0, 0, this.$refs.myCanvas.width, this.$refs.myCanvas.height);
      this.context.restore();
    },
    // 虚化背景
    handleSegmentationResults2(results) {
      this.context.save();
      this.context.clearRect(0, 0, this.$refs.myCanvas.width, this.$refs.myCanvas.height);

      // 先画上分割蒙版
      this.context.drawImage(results.segmentationMask, 0, 0, this.$refs.myCanvas.width, this.$refs.myCanvas.height);

      this.context.globalCompositeOperation = "source-out";

      // 创建一个新的Canvas用于模糊处理
      const tempCanvas = document.createElement("canvas");
      tempCanvas.width = this.$refs.myCanvas.width;
      tempCanvas.height = this.$refs.myCanvas.height;
      let tempCtx = tempCanvas.getContext('2d');
      tempCtx.drawImage(results.image, 0, 0, this.$refs.myCanvas.width, this.$refs.myCanvas.height);
      // 使用StackBlur进行模糊处理
      StackBlur.canvasRGBA(tempCanvas, 0, 0, this.$refs.myCanvas.width, this.$refs.myCanvas.height, 10);

      // 将模糊后的图像画回主Canvas
      this.context.drawImage(tempCanvas, 0, 0, this.$refs.myCanvas.width, this.$refs.myCanvas.height);

      this.context.globalCompositeOperation = "destination-atop";

      // 绘制前景图像
      this.context.drawImage(results.image, 0, 0, this.$refs.myCanvas.width, this.$refs.myCanvas.height);
      this.context.restore();
    },
    changeCheckBoxValue(key){
      // 底部菜单值变更
      if(!this.showHangup){
        //未建立连接之前，不允许修改
        Toast("接続中です、操作できません。")
        return
      }
      this.tool_value[key] = !this.tool_value[key];
    },
    openDetail() {
      if(!this.showHangup){
        //未建立连接之前，不允许修改
        Toast("接続中です、操作できません。")
        return
      }
      this.detailShow = true;
      this.back_tool_value = Object.assign({}, this.back_tool_value, this.tool_value);
    },
    async saveDetail() {
      this.detailShow = false;
      // 保存前检测
      // 虚拟背景、虚化背景同时只能开启一个
      if(this.tool_value.checkedBackground && this.tool_value.checkedBlurBackground ){
        this.tool_value = Object.assign({}, this.tool_value, this.back_tool_value);
        Toast("背景のぼかしとバーチャル背景を同時に開けません。");
        return;
      }
      // 检查是否已经上传了背景图像
      let userInfo = JSON.parse(localStorage.getItem(process.env.VUE_APP_USER_KEY));
      if(this.tool_value.checkedBackground && !userInfo.backgroundpath){
        this.tool_value = Object.assign({}, this.tool_value, this.back_tool_value);
        Toast.fail("背景画像をアップロードしてください");
        return;
      }
      // 远程操作权限
      if(this.canUseCameraAudioRemoteControl){
        const cameraChanged = this.tool_value.checkedCamera != this.back_tool_value.checkedCamera;
        const audioChanged = this.tool_value.checkedAudio != this.back_tool_value.checkedAudio;
        const cameraRearChanged = this.canUseRemoteControl
          && this.tool_value.checkedCameraRear != this.back_tool_value.checkedCameraRear;
        if (cameraChanged || audioChanged || cameraRearChanged) {
          CheckOperationAuth(this.remoteuser[2]).then((res) => {
            if (res.data.code >= 0) {
              let msg = {
                "method":"changeController"
              };
              if (cameraChanged) {
                msg['changeCameraStatus'] = this.tool_value.checkedCamera;
              }else{
                msg['changeCameraStatus'] = null;
              }
              if (audioChanged) {
                msg['changeAudioStatus'] = this.tool_value.checkedAudio;
              }else{
                msg['changeAudioStatus'] = null;
              }
              if (cameraRearChanged) {
                msg['changeCameraRearStatus'] = this.tool_value.checkedCameraRear;
              }else{
                msg['changeCameraRearStatus'] = null;
              }
              // 同步发送给对方
              this.videocall.data({
                text: JSON.stringify(msg),
                error: function () {console.log('エラー');},
                success: function () {},});
            } else {
              this.tool_value = Object.assign({}, this.tool_value, this.back_tool_value);
              Toast("遠隔操作権限がありません");
              return;
            }
          });
        }
      }
      // 虚化背景
      if(this.tool_value.checkedBlurBackground != this.back_tool_value.checkedBlurBackground
        || this.tool_value.checkedBackground != this.back_tool_value.checkedBackground){
        // 虚化背景或者虚拟背景有变动
        await this.changeVideoSource();
      }
      // 音声を文字化する
      if (this.tool_value.checkedSubtitle != this.back_tool_value.checkedSubtitle && this.controller_data.mkShow) {
        if (this.tool_value.checkedSubtitle) {
          this.startWebSpeech();
        } else {
          this.stopWebSpeech();
        }
      }else{
        this.tool_value.checkedSubtitle = false;
      }
      // 画面を録画する
      if(this.canRecordCurrentCall){
        if(this.tool_value.checkedVideotape != this.back_tool_value.checkedVideotapeBackups) {
          if (this.tool_value.checkedVideotape) {
            this.startRecord();
          } else {
            this.stopRecord();
          }
        }
      }

      // 自身画面表示ON/OFF（スピーカービューのみ反映）
      if (this.tool_value.checkedSelfView !== this.back_tool_value.checkedSelfView) {
        const enabled = this.tool_value.checkedSelfView;
        if (!this.frame) {
          if (enabled) {
            this.my_video_show = true;
            this.showMyvideoButton = false;
          } else {
            this.my_video_show = false;
            this.showMyvideoButton = false;
          }
        }
        const detail = { self_view_flg: enabled ? 1 : 0 };
        await UpdateUserWithoutId({detail:detail});
        let userInfo = JSON.parse(localStorage.getItem(process.env.VUE_APP_USER_KEY)) || {};
        userInfo.self_view_flg = enabled ? "1" : "0";
        localStorage.setItem(process.env.VUE_APP_USER_KEY, JSON.stringify(userInfo));
      }
    },
    stopCanvas(){
      // 清理 `canvas` 内容
      if (this.rafId) {
        cancelAnimationFrame(this.rafId);
        this.rafId = null;
      }
      // 清理视频元素的事件监听
      const videoElement = JQuery("#soucevideo").get(0);
      if (videoElement && videoElement.playingListener) {
        videoElement.removeEventListener("playing", videoElement.playingListener);
        videoElement.playingListener = null;
      }
      if (this.canvasSourceStream) {
        this.stopMediaTarget(this.canvasSourceStream);
        this.canvasSourceStream = null;
      }
      if (videoElement) {
        videoElement.srcObject = null;
      }

      if(this.context && this.$refs.myCanvas){
        this.context.clearRect(0, 0,this.$refs.myCanvas.width, this.$refs.myCanvas.height);
      }

      this.context = null;
      if (this.image) {
        this.image.onload = null;
        this.image.onerror = null;
      }
      this.image = null;

    },
    async startRecord() {
      // 作为录像人开启录像
      if (this.recordDisable) {
        Toast("他の人が録画しています。");
        this.tool_value.checkedVideotape = !this.tool_value.checkedVideotape;
      } else if (!this.isRecording) {
        let record_filename = randNumStr(6) + new Date().getTime();
        let userRet = await RefreshUserInfo();
        let userInfo = userRet.data.data.user;
        localStorage.setItem(process.env.VUE_APP_USER_KEY, JSON.stringify(userInfo));
        let msg = {
          method:"doRecord",
          record_filename:record_filename,
        };
        this.record_filename = record_filename
        // 同步发送给对方
        this.videocall.data({
          text: JSON.stringify(msg),
          error: function () {console.log('エラー');},
          success: function () {},});
        this.doRecord(msg);
        this.$root.saveVideoRecordLog("recordStart",userInfo.login_account_id,record_filename,0
            ,this.myuser[4],this.remoteuser[4]);
      }
    },
    stopRecord() {
      if (this.recordDisable) {
        Toast("他の人が録画しています。");
        this.controller_data.checkedVideotape = !this.controller_data.checkedVideotape;
      } else if (this.isRecording) {
        let msg = {method:"finishRecord"};
        // 同步发送给对方
        this.videocall.data({
          text: JSON.stringify(msg),
          error: function () {console.log('エラー');},
          success: function () {},});
        this.finishRecord();
        this.$root.saveVideoRecordLog("recordStop",null,this.record_filename,1);
      }
    },
    doRecord(msg){
      let record_filename = "/ebs/web/server/storage/video/source/" + msg["record_filename"];
      if(this.controller_data.userType == 'callUser'){
        record_filename = record_filename + "_call";
      }else if(this.controller_data.userType == 'answerUser'){
        record_filename = record_filename + "_answer";
      }
      Toast("録画開始");
      this.isRecording = true;
      this.videocall.send({
        message: {
          request: "set",
          record: true,
          filename: record_filename,
        },
      });
    },
    finishRecord(){
      Toast("録画終了");
      this.isRecording = false;
      this.recordDisable = false;
      this.videocall.send({ message: { request: "set", record: false } });
    },
    async shareScreen(){
      if(this.permissionError){
        // 摄像头获取失败 直接false
        Toast("カメラ権限が異常です。");
        return;
      }
      this.tool_value.checkedShareScreen = !this.tool_value.checkedShareScreen;
      if(this.tool_value.checkedShareScreen){
        // 开启屏幕共享
        try{
          this.shareScreenStream = await navigator.mediaDevices.getDisplayMedia({ video:true });
          this.videocall.createOffer({tracks: [{ type: 'video', replace: true, capture: this.shareScreenStream.getVideoTracks()[0] }],});
        }catch(error){
          // 开启时直接选择取消
          Toast.fail("起動に失敗した");
          this.tool_value.checkedShareScreen = false;
        }
      }else{
        // 关闭屏幕共享
        if(this.shareScreenStream){
          this.shareScreenStream.getTracks().forEach(track => track.stop());
          this.shareScreenStream= null;
        }
        await this.changeVideoSource();
      }
      // 同步发送
      let msg = {
        method:"changeShareStatus",
        status:this.tool_value.checkedShareScreen,
      }
      // 同步发送给对方
      this.videocall.data({
        text: JSON.stringify(msg),
        error: function () {console.log('エラー');},
        success: function () {},});
    },
    async changeVideoSource(){
      if(this.permissionError){
        // 摄像头获取失败 直接false
        Toast("カメラ権限が異常です。");
        return;
      }
      // 如果当前开启了屏幕共享 只记录值
      if(!this.tool_value.checkedShareScreen){
        // 获取摄像头
        // let newStream = await navigator.mediaDevices.getUserMedia({ video: { facingMode: { exact: this.facingMode } } })
        let newStream = await navigator.mediaDevices.getUserMedia({ video: { facingMode:this.facingMode } })
            .catch((error) => {
              console.log(error);
              this.tool_value = Object.assign({}, this.tool_value, this.back_tool_value);
              Toast("カメラ権限が異常です。");
              return;
            });
        // 如果没有开启屏幕共享 则切换视频源
        if(newStream){
          let background_flg = 0;
          if(this.tool_value.checkedBackground){
            background_flg = 1;
            // 开启虚拟背景
            this.createCanvas(newStream,'img');
            this.videocall.createOffer({tracks: [{ type: 'video', replace: true, capture: this.$refs.myCanvas.captureStream().getVideoTracks()[0] }],});
          }else if(this.tool_value.checkedBlurBackground){
            background_flg = 2;
            // 开启模糊背景
            this.createCanvas(newStream,'back');
            this.videocall.createOffer({tracks: [{ type: 'video', replace: true, capture: this.$refs.myCanvas.captureStream().getVideoTracks()[0] }],});
          }else{
            background_flg = 0;
            this.stopCanvas();
            this.videocall.createOffer({tracks: [{ type: 'video', replace: true, capture: newStream.getVideoTracks()[0] }],});
          }
          // 更新保存选择下次使用
          let userInfo = JSON.parse(localStorage.getItem(process.env.VUE_APP_USER_KEY));
          console.log(userInfo);
          const detail = { background_flg: background_flg };
          await UpdateUserWithoutId({detail:detail});
        }
      }
    },
  },
  watch: {
  },
};
</script>

<style scoped>
.popup-bg {
  background: rgba(0, 0, 0, 0.8);
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 100;
}
.btn {
  display: flex;
  justify-content: space-between;
  position: sticky;
  top: 0;
  background-color: white;
  z-index: 1;
}
.cancle {
  padding: 15px 0px 15px 18px;
  font-size: 18px;
  font-weight: bold;
}
.confirm {
  padding: 15px 18px 15px 0px;
  font-size: 18px;
  font-weight: bold;
}
.popup {
  position: absolute;
  bottom: 0;
  left: 0;
  z-index: 100;
  width: 100%;
  height: 400px;
  overflow: auto;
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
  background: #fff;
}
.pageView{
  display:flex;
  flex-direction: column;
  height:100vh;
  width: 100%;
}
.mainDiv{
  flex: 1;
  background-color:rgb(244, 251, 255);
  position: relative;
  display: flex;
  overflow: hidden;
}
.footDiv{
  height:70px;
  flex-wrap: wrap;
  align-items: center;
  align-content:center;
  width:100%;
  overflow-x: auto;
  overflow-y: hidden;
  white-space: nowrap;
  display:grid;
  justify-items: center;
  flex-shrink: 0;
}
.footDiv .footDiv-item{
  height: 61px;
  width: auto;
  display: flex;
  margin :5px;
  flex-direction: column;
  text-align: center;
}
@media (hover: hover) and (pointer: fine) {
  .footDiv .footDiv-item:hover{
    background-color: #bdbbbb;
  }
  .footDiv .footDiv-item:hover * {
    cursor: pointer!important;
  }
}
.footDiv .footDiv-item img{
  width: 80px;
  height: calc(100% - 17px);
}
.footDiv .iconSpan{
  font-size: 15px;
  margin-top:2px;
}
</style>
